(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[589],{

/***/ 51574:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ("/_next/static/media/favourite@3x.304910046a5255d84fbda2e072be974f.png");

/***/ }),

/***/ 18356:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ("/_next/static/media/heartIcon@3x.f4be81919fc6435b00ccf854bbbd77fd.png");

/***/ }),

/***/ 36532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




var Button = function(param) {
    var title = param.title, url = param.url;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var btn_handler = function() {
        if (url) {
            router.push(url);
        } else {
            console.log("Click");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: url,
        className: "btn_outline hover:text-white border border-gray-900 hover:bg-gray-800 w-full sm:w-auto",
        children: title
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 46675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);






var colors = {
    indigo: [
        "bg-indigo-50 text-indigo-600 hover:bg-indigo-200 hover:text-indigo-700 focus:ring-indigo-500",
        "text-indigo-300 group-hover:text-indigo-400", 
    ],
    pink: [
        "bg-pink-50 text-pink-600 hover:bg-pink-100 hover:text-pink-700 focus:ring-pink-600",
        "text-pink-300 group-hover:text-pink-400", 
    ],
    sky: [
        "bg-sky-50 text-sky-600 hover:bg-sky-100 hover:text-sky-700 focus:ring-sky-600",
        "text-sky-300 group-hover:text-sky-400", 
    ],
    blue: [
        "bg-blue-50 text-blue-600 hover:bg-blue-100 hover:text-blue-700 focus:ring-blue-600",
        "text-blue-300 group-hover:text-blue-400", 
    ],
    gray: [
        "bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-gray-900 focus:ring-gray-500",
        "text-gray-300 group-hover:text-gray-400", 
    ]
};
function Button(_param) {
    var _color = _param.color, color = _color === void 0 ? "gray" : _color, href = _param.href, children = _param.children, _className = _param.className, className = _className === void 0 ? "" : _className, _reverse = _param.reverse, reverse = _reverse === void 0 ? false : _reverse, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "color",
        "href",
        "children",
        "className",
        "reverse"
    ]);
    var colorClasses = typeof color === "string" ? colors[color] : color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("group inline-flex items-center h-9 rounded-full text-sm font-semibold whitespace-nowrap px-3 focus:outline-none focus:ring-2", colorClasses[0], className, reverse && "flex-row-reverse")
        }, props), {
            children: [
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("overflow-visible", reverse ? "mr-3" : "ml-3", colorClasses[1]),
                    width: "3",
                    height: "6",
                    viewBox: "0 0 3 6",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: reverse ? "M3 0L0 3L3 6" : "M0 0L3 3L0 6"
                    })
                })
            ]
        }))
    });
}


/***/ }),

/***/ 15253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Widont; }
/* harmony export */ });
function Widont(param) {
    var children = param.children;
    return children.replace(/ ([^ ]+)$/, "\xa0$1");
}


/***/ }),

/***/ 47262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xo": function() { return /* reexport safe */ _components_Widont__WEBPACK_IMPORTED_MODULE_4__.X; },
/* harmony export */   "YS": function() { return /* binding */ Caption; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; },
/* harmony export */   "qk": function() { return /* binding */ IconContainer; },
/* harmony export */   "y8": function() { return /* binding */ BigText; }
/* harmony export */ });
/* unused harmony exports Link, InlineCode, themeTabs */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46675);
/* harmony import */ var _components_Widont__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15253);





function IconContainer(_param) {
    var tmp = _param.as, Component = tmp === void 0 ? "div" : tmp, color = _param.color, _className = _param.className, className = _className === void 0 ? "" : _className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "as",
        "color",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "w-16 h-16 rounded-full ring-1 ring-gray-900/10 shadow overflow-hidden ".concat(className)
    }, props));
}
function Caption(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "mt-2 font-semibold ".concat(className)
    }, props));
}
function BigText(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "mt-4 text-3xl sm:text-4xl text-gray-900 font-extrabold tracking-tight ".concat(className)
    }, props));
}
function Paragraph(_param) {
    var tmp = _param.as, Component = tmp === void 0 ? "p" : tmp, _className = _param.className, className = _className === void 0 ? "" : _className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "as",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "mt-4 max-w-3xl space-y-6 ".concat(className)
    }, props));
}
function Link(_param) {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(Button, _object_spread({
        className: clsx("mt-8", className)
    }, props));
}
function InlineCode(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("code", _object_spread({
        className: "font-mono text-gray-900 font-medium ".concat(className)
    }, props));
}

var themeTabs = {
    Simple: function(selected) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M5 11a4 4 0 0 1 4-4h30a4 4 0 0 1 4 4v26a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V11Z",
                    fill: "currentColor",
                    fillOpacity: selected ? ".1" : "0",
                    stroke: "currentColor",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15 7v34",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                })
            ]
        });
    },
    Playful: function(selected) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M5 8h36v32H5V8Z",
                    fill: "currentColor",
                    fillOpacity: selected ? ".1" : "0"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M42 29V11a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v26a4 4 0 0 0 4 4h19",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M33.662 41.736a1 1 0 0 1-1.1-1.322l3.08-8.68a1 1 0 0 1 1.736-.274l5.6 7.299a1 1 0 0 1-.637 1.596l-8.679 1.38Z",
                    fill: selected ? "currentColor" : "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M14 7v34",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M22.8 19.949a2 2 0 0 1 2.4-1.5l5.851 1.352a2 2 0 0 1 1.5 2.399l-1.352 5.851a2 2 0 0 1-2.399 1.5l-5.851-1.352a2 2 0 0 1-1.5-2.399l1.352-5.851Z",
                    fill: selected ? "currentColor" : "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
    },
    Elegant: function(selected) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M6 8h32a4 4 0 0 1 4 4v28H6V8Z",
                    fill: "currentColor",
                    fillOpacity: selected ? ".1" : "0"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M43 21v16a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4h20M15 7v34",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M37 7c0 1.101 0 6-6 6 1.101 0 6 0 6 6 0-6 4.899-6 6-6-6 0-6-4.899-6-6ZM31 21c0 .734 0 4-4 4 .734 0 4 0 4 4 0-4 3.266-4 4-4-4 0-4-3.266-4-4Z",
                    fill: selected ? "currentColor" : "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
    },
    Brutalist: function(selected) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M9 41h30a4 4 0 0 0 4-4V11a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v26a4 4 0 0 0 4 4Z",
                    fill: "currentColor",
                    fillOpacity: selected ? ".1" : "0",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15 7v34M17 13h-2M43 13h-6",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M21 29V15a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2Z",
                    fill: selected ? "currentColor" : "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M25 31v2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V19a2 2 0 0 0-2-2h-2",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                })
            ]
        });
    }
};


/***/ }),

/***/ 81054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tradly_home_AnyDevices; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Widont.js
var Widont = __webpack_require__(15253);
// EXTERNAL MODULE: ./src/components/home/common.js
var common = __webpack_require__(47262);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.esm.js
var tabs_esm = __webpack_require__(66311);
;// CONCATENATED MODULE: ./src/img/tradly/hero_icons/launchwherever.svg
var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgLaunchwherever(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 20,
    fill: "#FF4A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.552 20.173v17.379H12.448v-17.38a2.414 2.414 0 012.414-2.413h20.276a2.414 2.414 0 012.414 2.414z",
    fill: "#CCDCE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.759 39h-19.31c-.8 0-1.449-.648-1.449-1.448v-1.449h9.655l.966.966h6.758l.966-.966H39v1.449c0 .8-.648 1.448-1.448 1.448h-5.793z",
    fill: "#ABBAC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.38 19.69h21.24v14.482H14.38V19.69z",
    fill: "#0093BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.62 19.69H31.76L17.276 34.171H35.62V19.69z",
    fill: "#047FA7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.69 27.896h10.62a1.931 1.931 0 010 3.863H19.69a1.931 1.931 0 010-3.863z",
    fill: "#FFC119"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.31 27.896h-6.758l-3.863 3.863H30.31a1.931 1.931 0 000-3.863z",
    fill: "#FAAC2B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.069 17.759v-2.897a1.931 1.931 0 013.862 0h1.93a3.862 3.862 0 10-7.723 0v2.897h1.93z",
    fill: "#CCDCE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.793 17.759a.966.966 0 00-.965-.966h-9.655a.966.966 0 00-.966.966v6.758c0 .533.432.966.965.966h5.794l4.827-4.828v-2.896z",
    fill: "#FFC119"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.965 25.483h3.862a.966.966 0 00.966-.966v-3.862l-4.828 4.828z",
    fill: "#FAAC2B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.449 20.655a1.448 1.448 0 11-2.897 0 1.448 1.448 0 012.897 0z",
    fill: "#EA732D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.518 21.621h.965v1.931h-.965v-1.93zM19.69 29.345h.965v.965h-.965v-.965zM21.621 29.345h.966v.965h-.966v-.965zM23.552 29.345h.966v.965h-.966v-.965zM25.483 29.345h.965v.965h-.965v-.965z",
    fill: "#EA732D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.207 25.965a3.38 3.38 0 11-6.759 0 3.38 3.38 0 016.759 0z",
    fill: "#EB4042"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.828 27.413a.483.483 0 01-.342-.141l-1.448-1.448.683-.683 1.107 1.107 3.038-3.038.682.683-3.379 3.379a.483.483 0 01-.341.141z",
    fill: "#E9F0F1"
  })));
}
/* harmony default export */ var launchwherever = ("/_next/static/media/launchwherever.eaf9d666a9c5cdfde4d123e795b7d44a.svg");

// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/feature.js
var feature = __webpack_require__(6597);
// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/common.module.scss
var common_module = __webpack_require__(27087);
var common_module_default = /*#__PURE__*/__webpack_require__.n(common_module);
// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/data/imagesUrl.js
var imagesUrl = __webpack_require__(62724);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(90387);
// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/data/HomePageData.js
var HomePageData = __webpack_require__(9936);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/HomePageFeature/Header/HeaderCategories.jsx





var HeaderCategories = function() {
    var router = (0,client_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: " flex items-center",
            children: HomePageData.categories === null || HomePageData.categories === void 0 ? void 0 : HomePageData.categories.map(function(item) {
                var ref;
                var query = item.name !== "More" ? {
                    name: item.name.replace(/\s/g, "-"),
                    category_id: item.id,
                    page: 1
                } : "";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: [
                            " min-h-[44px] px-3 flex justify-center items-center cursor-pointer transition duration-300 hover:text-primary ",
                            (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.name) === item.name.replace(/\s/g, "-") ? "text-primary" : "", 
                        ].join(" "),
                        children: item.name === "More" ? item.name : item.name.length > 12 ? item.name.substring(0, 11) + "." : item.name
                    })
                }, Math.random());
            })
        })
    });
};
/* harmony default export */ var Header_HeaderCategories = (HeaderCategories);

// EXTERNAL MODULE: ./node_modules/next/dist/server/router.js
var router = __webpack_require__(93288);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/HomePageFeature/SearchBox/SearchBox.jsx




var SearchBox_SearchBox = function() {
    var router = (0,client_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " h-12 md:w-[200px] xl:w-[270px] rounded-[8px] bg-[rgba(250, 250, 250, 0.93)] shadow-c-sm flex items-center overflow-hidden border border-[rgba(34,34,34,.2] ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "21",
                height: "21",
                viewBox: "0 0 21 21",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "ml-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M20.7099 19.2899L16.9999 15.6099C18.44 13.8143 19.1374 11.5352 18.9487 9.2412C18.76 6.94721 17.6996 4.81269 15.9854 3.27655C14.2713 1.74041 12.0337 0.919414 9.73283 0.982375C7.43194 1.04534 5.24263 1.98747 3.61505 3.61505C1.98747 5.24263 1.04534 7.43194 0.982375 9.73283C0.919414 12.0337 1.74041 14.2713 3.27655 15.9854C4.81269 17.6996 6.94721 18.76 9.2412 18.9487C11.5352 19.1374 13.8143 18.44 15.6099 16.9999L19.2899 20.6799C19.3829 20.7736 19.4935 20.848 19.6153 20.8988C19.7372 20.9496 19.8679 20.9757 19.9999 20.9757C20.1319 20.9757 20.2626 20.9496 20.3845 20.8988C20.5063 20.848 20.6169 20.7736 20.7099 20.6799C20.8901 20.4934 20.9909 20.2442 20.9909 19.9849C20.9909 19.7256 20.8901 19.4764 20.7099 19.2899ZM9.9999 16.9999C8.61544 16.9999 7.26206 16.5894 6.11091 15.8202C4.95977 15.051 4.06256 13.9578 3.53275 12.6787C3.00293 11.3996 2.86431 9.99214 3.13441 8.63427C3.4045 7.27641 4.07119 6.02912 5.05016 5.05016C6.02912 4.07119 7.27641 3.4045 8.63427 3.13441C9.99214 2.86431 11.3996 3.00293 12.6787 3.53275C13.9578 4.06256 15.051 4.95977 15.8202 6.11091C16.5894 7.26206 16.9999 8.61544 16.9999 9.9999C16.9999 11.8564 16.2624 13.6369 14.9497 14.9497C13.6369 16.2624 11.8564 16.9999 9.9999 16.9999Z",
                    fill: "#121212"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: "h-full bg-transparent w-full pl-3 placeholder-gray-400 outline-none border-none ring-0 focus:ring-0",
                type: "text",
                placeholder: "Search"
            })
        ]
    });
};
/* harmony default export */ var HomePageFeature_SearchBox_SearchBox = (SearchBox_SearchBox);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/HomePageFeature/Categories/Categories.jsx
/* eslint-disable react/prop-types */ /* eslint-disable no-nested-ternary */ 



var Categories = function(param) {
    var categories = param.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: " grid grid-cols-[144px,144px] xs:grid-cols-3 gap-[23px] sm:gap-0 sm:flex sm:flex-wrap justify-center md:justify-start items-center",
            children: categories === null || categories === void 0 ? void 0 : categories.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: " sm:mr-4 sm:mb-6 bg-[#ffffff] rounded-xl py-4 flex flex-col justify-between items-center border border-transparent shadow-c-sm hover:border-primary hover:bg-primary_light w-[144px] h-[144px] md:w-[100px] md:h-[100px] cursor-pointer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " w-[46px] h-[46px] md:w-[32px] md:h-[32px] relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: item.image_path,
                                alt: item.name,
                                title: item.name,
                                layout: "fill",
                                objectFit: "cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: " w-11/12 mx-auto min-h-[5px] text-primary text-xs font-medium flex justify-center items-center text-center",
                            children: item.name === "All Categories" ? item.name : item.name.length > 11 ? item.name.substring(0, 10) : item.name
                        })
                    ]
                });
            })
        })
    });
};
/* harmony default export */ var Categories_Categories = (Categories);

// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 3 modules
var swiper_react = __webpack_require__(2261);
// EXTERNAL MODULE: ./node_modules/swiper/modules/index.mjs + 26 modules
var modules = __webpack_require__(99304);
// EXTERNAL MODULE: ./src/img/tradly/favourite@3x.png
var favourite_3x = __webpack_require__(51574);
// EXTERNAL MODULE: ./src/img/tradly/heartIcon@3x.png
var heartIcon_3x = __webpack_require__(18356);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/HomePageFeature/LatestEvents/LatestEvent.jsx
/* eslint-disable react/prop-types */ /* eslint-disable camelcase */ 




// Import Swiper styles

// import Swiper core and required modules



// install Swiper modules
var LatestEvent = function(param) {
    var products = param.products;
    var getThumbnailImage = function getThumbnailImage(file) {
        var filename = file.split("/").pop();
        var fileURl = file.replace(filename, "thumb_" + filename);
        return fileURl;
    };
    var ref;
    // const { isSuccess } = useSelector(listingSelector);
    var router = (0,client_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: " text-2xl text-black font-semibold",
                        children: products.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: " block text-base text-primary font-semibold cursor-pointer",
                        children: "View All"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " mt-4 flex justify-start ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    slidesPerView: "auto",
                    slidesPerGroup: 1,
                    spaceBetween: 16,
                    loop: false,
                    navigation: false,
                    style: {
                        paddingBottom: "20px"
                    },
                    modules: [
                        modules/* Navigation */.W_,
                        modules/* Pagination */.tl
                    ],
                    children: products === null || products === void 0 ? void 0 : (ref = products.listings) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                        var ref, ref1, ref2, ref3, ref4;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: " w-[190px] h-[302px] rounded mr-4 overflow-hidden",
                            style: {
                                width: "190px",
                                minHeight: "210px",
                                paddingBottom: "10px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: " block w-[190px] min-h-[210px] bg-[#FEFEFE] rounded mr-4 overflow-hidden cursor-pointer shadow-c-xsm relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[190px] h-[190px] relative",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: getThumbnailImage(item.images[0]),
                                                    alt: item.title,
                                                    layout: "fill",
                                                    objectFit: "cover"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-2 pl-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: " text-sm leading-[15px] font-semibold text-primary",
                                                        children: item.title.length > 18 ? item.title.substring(0, 18) + ".." : item.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: " mt-1 flex items-center flex-wrap",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-[10px] leading-4 font-medium text-gray-500",
                                                                children: item.list_price.currency
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-[14px] leading-4 font-medium text-gray-600 ml-1",
                                                                children: item.list_price.amount
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: " pl-2 mt-4 mb-[14px] flex items-center",
                                                children: [
                                                    (item === null || item === void 0 ? void 0 : (ref = item.account) === null || ref === void 0 ? void 0 : ref.images.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "h-5 w-5 rounded-full overflow-hidden relative",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: item === null || item === void 0 ? void 0 : item.account.images[0],
                                                            layout: "fill",
                                                            objectFit: "cover"
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        className: "h-5 w-5",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: "2",
                                                            d: "M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "ml-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: " text-[10px] leading-3 text-[#4F4F4F] font-medium mix-blend-normal",
                                                                children: (item === null || item === void 0 ? void 0 : (ref1 = item.account) === null || ref1 === void 0 ? void 0 : ref1.name.length) > 20 ? (item === null || item === void 0 ? void 0 : (ref2 = item.account) === null || ref2 === void 0 ? void 0 : ref2.name.substring(0, 18)) + ".." : item === null || item === void 0 ? void 0 : (ref3 = item.account) === null || ref3 === void 0 ? void 0 : ref3.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "text-[10px] leading-3 text-[#4F4F4F] font-medium opacity-50",
                                                                children: [
                                                                    item === null || item === void 0 ? void 0 : (ref4 = item.account) === null || ref4 === void 0 ? void 0 : ref4.total_followers,
                                                                    " Followers"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " h-[40px] w-[40px] cursor-pointer [z-100] absolute top-0 right-0",
                                        children: item.liked ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: favourite_3x/* default */.Z,
                                            alt: "follow button",
                                            layout: "fill",
                                            objectFit: "cover",
                                            require: true
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: heartIcon_3x/* default */.Z,
                                            alt: "follow button",
                                            layout: "fill",
                                            objectFit: "cover",
                                            require: true
                                        })
                                    })
                                ]
                            })
                        }, Math.random() * 3000000);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var LatestEvents_LatestEvent = (LatestEvent);

;// CONCATENATED MODULE: ./src/img/tradly/play-store-image2.png
/* harmony default export */ var play_store_image2 = ("/_next/static/media/play-store-image2.6af07eeb1e7b6168c3151fe48d648152.png");
// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/data/socialIcons.js
var socialIcons = __webpack_require__(76025);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/HomePageFeature/Footer/Footer.jsx









var Footer = function() {
    var getThumbnailImage = function getThumbnailImage(file) {
        var filename = file.split("/").pop();
        var fileURl = file.replace(filename, "thumb_" + filename);
        return fileURl;
    };
    var router = (0,client_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full h-full py-4 grid grid-cols-2 md:grid-cols-3 gap-10 border-b border-[rgba(216, 216, 216, 0.5)]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " col-span-2 md:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: " w-[180px] h-[50px] relative flex justify-start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: getThumbnailImage(imagesUrl.logo),
                                    layout: "fill",
                                    objectFit: "contain",
                                    alt: "logo"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: " block mt-4 ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    // onClick={() => window.open(general_configs?.app_download_link)}
                                    className: " text-base text-[#4F4F4F] font-medium rounded-lg overflow-hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: play_store_image2,
                                        className: "w-[180px]",
                                        objectFit: "cover",
                                        alt: "logo"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-4 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-base font-semibold pb-4",
                                        children: "Follow us on social media"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: socialIcons.facebook_icon
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: socialIcons.youtube_icon
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: socialIcons.twitter_icon
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: socialIcons.snapchat_icon
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: socialIcons.telegram_icon
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: socialIcons.whatsapp_icon
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: " text-base font-semibold pb-4",
                                children: "Categories"
                            }),
                            HomePageData.categories === null || HomePageData.categories === void 0 ? void 0 : HomePageData.categories.map(function(item, index, array) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-4 ",
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                // }
                                                className: [
                                                    "  text-[#4F4F4F]    cursor-pointer transition duration-300 hover:text-primary  text-left", 
                                                ].join(" "),
                                                children: item.name.length > 20 ? item.name.substring(0, 19) + "." : item.name
                                            })
                                        })
                                    ]
                                }, Math.random());
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: " text-base font-semibold pb-4",
                                children: "Links"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: " block pb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    // onClick={() => window.open(general_configs?.terms_url)}
                                    className: " text-base text-[#4F4F4F] font-medium text-left",
                                    children: "Terms & Conditions"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: " block pb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    // onClick={() => window.open(general_configs?.privacy_policy_url)}
                                    className: " text-base text-[#4F4F4F] font-medium",
                                    children: "Privacy Policy"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: " block pb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    // onClick={() => window.open(general_configs?.support_url)}
                                    className: " text-base text-[#4F4F4F] font-medium",
                                    children: "Support"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "py-2 flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: " text-xs text-secondary mr-4",
                        children: "\xa9 All rights reserved"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: " text-xs text-[#4F4F4F] font-medium",
                        children: "Sitemap"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Footer_Footer = (Footer);

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/webFeature.js











var WebFeature = function() {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (common_module_default()).bg_style,
        style: {
            paddingTop: "20px",
            paddingBottom: "20px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full h-[500px] px-5 md:px-10 md:pb-10 pt-0 overflow-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " sticky top-0 z-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " min-h-[70px] px-[25px] shadow-c-sm bg-white top-0 overflow-x-hidden relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex pt-[24px] w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " absolute left-0 right-0 flex justify-center ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: " flex items-center relative cursor-pointer ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: imagesUrl.logo,
                                                height: 44,
                                                width: 250,
                                                objectFit: "contain",
                                                alt: "logo"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " z-[100] ml-auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: " flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: " ms:mr-2 ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: " cursor-pointer w-[34px] h-[44px] px-[2px] flex justify-center items-center",
                                                        children: imagesUrl.store_icon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: " ms:mr-2 ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "cursor-pointer w-[34px] h-[44px] px-[6px] flex justify-center items-center",
                                                        children: imagesUrl.wishlist_icon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                            className: " w-[90px] bg-primary text-sm text-white py-[6px] flex items-center justify-center rounded-md ",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: " hidden ms:block ",
                                                                    children: [
                                                                        " ",
                                                                        imagesUrl.sign_in_icon
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: " ms:ml-[6px]",
                                                                    children: " Log In"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-3 pb-[16px] flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCategories, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageFeature_SearchBox_SearchBox, {})
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-[#f6f9ff] px-[25px] pt-5 pb-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " w-full h-[240px] relative rounded-lg overflow-hidden mb-9",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: HomePageData.home_page_data.promo_banners[0].image_path,
                                        alt: "Banner Image",
                                        layout: "fill",
                                        objectFit: "cover"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories_Categories, {
                                    categories: HomePageData.home_page_data.categories
                                })
                            }),
                            (ref = HomePageData.home_page_data.collections) === null || ref === void 0 ? void 0 : ref.map(function(collection) {
                                var scope_type = collection.scope_type;
                                // if (scope_type === 1 && marketplace_module === 1) {
                                //   return (
                                //     <div key={Math.random()}>
                                //       <StoresForFollow stores={collection} />
                                //     </div>
                                //   )
                                // }
                                if (scope_type === 4) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestEvents_LatestEvent, {
                                            products: collection
                                        })
                                    }, Math.random());
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-white min-h-[200px] left-0 bottom-0 px-[50px] 2xl:px-[12%] ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {})
                })
            ]
        })
    });
};
/* harmony default export */ var webFeature = (WebFeature);

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/TabletFeature.js














var TabletFeature = function() {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (common_module_default()).bg_style,
        style: {
            paddingTop: "20px",
            paddingBottom: "20px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-[768px] h-[700px] mx-auto px-5 md:px-10 md:pb-10 pt-0 overflow-auto ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " sticky top-0 z-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " min-h-[70px] px-[25px] shadow-c-sm bg-white top-0 overflow-x-hidden relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex pt-[24px] w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " absolute left-0 right-0 flex justify-center ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: " flex items-center relative cursor-pointer ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: imagesUrl.logo,
                                                height: 44,
                                                width: 250,
                                                objectFit: "contain",
                                                alt: "logo"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " z-[100] ml-auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: " flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: " ms:mr-2 ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: " cursor-pointer w-[34px] h-[44px] px-[2px] flex justify-center items-center",
                                                        children: imagesUrl.store_icon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: " ms:mr-2 ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "cursor-pointer w-[34px] h-[44px] px-[6px] flex justify-center items-center",
                                                        children: imagesUrl.wishlist_icon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                            className: " w-[90px] bg-primary text-sm text-white py-[6px] flex items-center justify-center rounded-md ",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: " hidden ms:block ",
                                                                    children: [
                                                                        " ",
                                                                        imagesUrl.sign_in_icon
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: " ms:ml-[6px]",
                                                                    children: " Log In"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-3 pb-[16px] flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCategories, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageFeature_SearchBox_SearchBox, {})
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-[#f6f9ff] px-[30px] pt-5 pb-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " w-full h-[240px] relative rounded-lg overflow-hidden mb-9",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: HomePageData.home_page_data.promo_banners[0].image_path,
                                        alt: "Banner Image",
                                        layout: "fill",
                                        objectFit: "fill"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories_Categories, {
                                    categories: HomePageData.home_page_data.categories
                                })
                            }),
                            (ref = HomePageData.home_page_data.collections) === null || ref === void 0 ? void 0 : ref.map(function(collection) {
                                var scope_type = collection.scope_type;
                                // if (scope_type === 1 && marketplace_module === 1) {
                                //   return (
                                //     <div key={Math.random()}>
                                //       <StoresForFollow stores={collection} />
                                //     </div>
                                //   )
                                // }
                                if (scope_type === 4) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestEvents_LatestEvent, {
                                            products: collection
                                        })
                                    }, Math.random());
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-white min-h-[200px] left-0 bottom-0 px-[50px] ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full h-full py-4 grid grid-cols-2 md:grid-cols-3 gap-10 border-b border-[rgba(216, 216, 216, 0.5)]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " col-span-2 md:col-span-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: " w-[180px] h-[50px] relative flex justify-start",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: imagesUrl.logo,
                                                layout: "fill",
                                                objectFit: "contain",
                                                alt: "logo"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: " block mt-4 ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                // onClick={() => window.open(general_configs?.app_download_link)}
                                                className: " text-base text-[#4F4F4F] font-medium rounded-lg overflow-hidden",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: play_store_image2,
                                                    className: "w-[180px]",
                                                    objectFit: "cover",
                                                    alt: "logo"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-4 ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "text-base font-semibold pb-4",
                                                    children: "Follow us on social media"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: socialIcons.facebook_icon
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: socialIcons.youtube_icon
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: socialIcons.twitter_icon
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: socialIcons.snapchat_icon
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: " text-base font-semibold pb-4",
                                            children: "Categories"
                                        }),
                                        HomePageData.categories === null || HomePageData.categories === void 0 ? void 0 : HomePageData.categories.map(function(item, index, array) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-4 ",
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            // }
                                                            className: [
                                                                "  text-[#4F4F4F]    cursor-pointer transition duration-300 hover:text-primary  text-left", 
                                                            ].join(" "),
                                                            children: item.name.length > 20 ? item.name.substring(0, 19) + "." : item.name
                                                        })
                                                    })
                                                ]
                                            }, Math.random());
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: " text-base font-semibold pb-4",
                                            children: "Links"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: " block pb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                // onClick={() => window.open(general_configs?.terms_url)}
                                                className: " text-base text-[#4F4F4F] font-medium text-left",
                                                children: "Terms & Conditions"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: " block pb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                // onClick={() => window.open(general_configs?.privacy_policy_url)}
                                                className: " text-base text-[#4F4F4F] font-medium",
                                                children: "Privacy Policy"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: " block pb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                // onClick={() => window.open(general_configs?.support_url)}
                                                className: " text-base text-[#4F4F4F] font-medium",
                                                children: "Support"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-2 flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: " text-xs text-secondary mr-4",
                                    children: "\xa9 All rights reserved"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: " text-xs text-[#4F4F4F] font-medium",
                                    children: "Sitemap"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var tradlyFeatures_TabletFeature = (TabletFeature);

// EXTERNAL MODULE: ./node_modules/react-outside-click-handler/index.js
var react_outside_click_handler = __webpack_require__(39834);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/HomePageFeature/Header/Drawer.jsx








var Drawer = function() {
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: " left-0 right-0 flex-col justify-center mb-2",
                children: [
                    logo && /*#__PURE__*/ _jsx("a", {
                        className: " block flex items-center relative cursor-pointer py-4",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: logo,
                            height: 44,
                            width: 250,
                            objectFit: "contain",
                            alt: "logo"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "pb-[10px] px-2",
                        children: /*#__PURE__*/ _jsx(SearchBox, {})
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: categories === null || categories === void 0 ? void 0 : categories.map(function(item) {
                    return /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx("div", {
                            className: [
                                "w-full h-12 flex   items-center     cursor-pointer  hover:bg-primary_light mb-1", 
                            ].join(" "),
                            children: /*#__PURE__*/ _jsx("p", {
                                className: [
                                    " text-sm font-semibold   ml-5 "
                                ].join(" "),
                                children: item.name
                            })
                        })
                    }, item.id);
                })
            })
        ]
    });
};
/* harmony default export */ var Header_Drawer = ((/* unused pure expression or super */ null && (Drawer)));

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/HomePageFeature/Header/Header3.jsx








var Header3 = function() {
    var ref = (0,react.useState)(false), isDrawerOpen = ref[0], setIsDrawerOpen = ref[1];
    var drawerOpen = function() {
        var drawer = document.getElementById("sideDrawer");
        drawer.classList.remove("-translate-x-full");
        setIsDrawerOpen(true);
    };
    var closeDrawer = function() {
        var drawer = document.getElementById("sideDrawer");
        setIsDrawerOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: " bg-white shadow-c-sm overflow-hidden relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full px-[16px] ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center py-[16px] relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "outline-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "h-6 w-6 mr-[13px] cursor-pointer",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: "2",
                                            d: "M4 6h16M4 12h16M4 18h16"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: imagesUrl.logo,
                                        height: 44,
                                        width: 150,
                                        objectFit: "contain",
                                        alt: "logo"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " hidden sm:block ms:mr-2 ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: " cursor-pointer w-[34px] h-[44px] px-[2px] flex justify-center items-center",
                                        children: imagesUrl.store_icon
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " ms:mr-2 ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "cursor-pointer w-[34px] h-[44px] px-[6px] flex justify-center items-center",
                                        children: imagesUrl.wishlist_icon
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: " w-[90px] bg-primary text-sm text-white py-[6px] flex items-center justify-center rounded-md ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: " hidden ms:block ",
                                                    children: [
                                                        " ",
                                                        imagesUrl.sign_in_icon
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: " ms:ml-[6px]",
                                                    children: " Log In"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Header_Header3 = (Header3);

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/MobileFeature.js















var MobileFeature = function() {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (common_module_default()).bg_style,
        style: {
            paddingTop: "20px",
            paddingBottom: "20px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-[405px] mx-auto max-h-[600px] md:max-h-[410px] px-5 md:px-10 md:pb-10 pt-0 overflow-auto relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " sticky top-0 z-10 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header3, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-[#f6f9ff] px-[25px] pt-5 pb-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " w-full h-[140px] relative rounded-lg overflow-hidden mb-9",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: HomePageData.home_page_data.promo_banners[0].image_path,
                                        alt: "Banner Image",
                                        layout: "fill",
                                        objectFit: "cover"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories_Categories, {
                                    categories: HomePageData.home_page_data.categories
                                })
                            }),
                            (ref = HomePageData.home_page_data.collections) === null || ref === void 0 ? void 0 : ref.map(function(collection) {
                                var scope_type = collection.scope_type;
                                // if (scope_type === 1 && marketplace_module === 1) {
                                //   return (
                                //     <div key={Math.random()}>
                                //       <StoresForFollow stores={collection} />
                                //     </div>
                                //   )
                                // }
                                if (scope_type === 4) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestEvents_LatestEvent, {
                                            products: collection
                                        })
                                    }, Math.random());
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-white min-h-[200px] left-0 bottom-0 px-[25px] ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full h-full py-4 grid grid-cols-2 gap-10 border-b border-[rgba(216, 216, 216, 0.5)]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " col-span-2 ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: " w-[180px] h-[50px] relative flex justify-start",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: imagesUrl.logo,
                                                layout: "fill",
                                                objectFit: "contain",
                                                alt: "logo"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: " block mt-4 ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                // onClick={() => window.open(general_configs?.app_download_link)}
                                                className: " text-base text-[#4F4F4F] font-medium rounded-lg overflow-hidden",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: play_store_image2,
                                                    className: "w-[180px]",
                                                    objectFit: "cover",
                                                    alt: "logo"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-4 ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "text-base font-semibold pb-4",
                                                    children: "Follow us on social media"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: socialIcons.facebook_icon
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: socialIcons.youtube_icon
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: socialIcons.twitter_icon
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: socialIcons.snapchat_icon
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: socialIcons.telegram_icon
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: socialIcons.whatsapp_icon
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: " text-base font-semibold pb-4",
                                            children: "Categories"
                                        }),
                                        HomePageData.categories === null || HomePageData.categories === void 0 ? void 0 : HomePageData.categories.map(function(item, index, array) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-4 ",
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            // }
                                                            className: [
                                                                "  text-[#4F4F4F]    cursor-pointer transition duration-300 hover:text-primary  text-left", 
                                                            ].join(" "),
                                                            children: item.name.length > 20 ? item.name.substring(0, 19) + "." : item.name
                                                        })
                                                    })
                                                ]
                                            }, Math.random());
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: " text-base font-semibold pb-4",
                                            children: "Links"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: " block pb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                // onClick={() => window.open(general_configs?.terms_url)}
                                                className: " text-base text-[#4F4F4F] font-medium text-left",
                                                children: "Terms & Conditions"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: " block pb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                // onClick={() => window.open(general_configs?.privacy_policy_url)}
                                                className: " text-base text-[#4F4F4F] font-medium text-left",
                                                children: "Privacy Policy"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: " block pb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                // onClick={() => window.open(general_configs?.support_url)}
                                                className: " text-base text-[#4F4F4F] font-medium",
                                                children: "Support"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-2 flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: " text-xs text-secondary mr-4",
                                    children: "\xa9 All rights reserved"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: " text-xs text-[#4F4F4F] font-medium",
                                    children: "Sitemap"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var tradlyFeatures_MobileFeature = (MobileFeature);

;// CONCATENATED MODULE: ./src/components/home/tradly-home/AnyDevices.jsx











function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
var AnyDevices = function() {
    var ref = (0,react.useState)([
        {
            id: 1,
            buttonTitle: "Mobile",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
            }),
            feature: tradlyFeatures_MobileFeature
        },
        {
            id: 2,
            buttonTitle: "tablet",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
            }),
            feature: tradlyFeatures_TabletFeature
        },
        {
            id: 3,
            buttonTitle: "Web",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            }),
            feature: webFeature
        }, 
    ]), categories = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-7xl mx-auto px-4 sm:px-6 md:px-8 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: launchwherever,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Caption */.YS, {
                className: "text-color5",
                children: "Any Apps"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* BigText */.y8, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Widont/* Widont */.X, {
                    children: "Launch wherever you want."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Paragraph */.nv, {
                children: "We prioritize Customer Choice, offering flexibility in app types (web, mobile, tablet, desktop, or custom). Through extensive POC, we've crafted a modular API, design components, text strings, and a versatile front-end stack, enabling your app to thrive across various platforms."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full sm:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_esm/* Tab.Group */.O.Group, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.List */.O.List, {
                            className: " mt-10 flex p-1 items-center gap-7 ",
                            children: categories.map(function(category) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_esm/* Tab */.O, {
                                    className: function(param) {
                                        var selected = param.selected;
                                        return classNames("w-[96px] py-2.5 text-sm leading-5 font-medium rounded-lg flex flex-col justify-center items-center gap-6  group outline-none", selected ? " transition duration-500 text-color5" : "text-gray-300  hover:text-gray-400");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-12 w-12",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            children: category.icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "",
                                            children: category.buttonTitle
                                        })
                                    ]
                                }, category);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.Panels */.O.Panels, {
                            className: "pt-10 xl:pt-0 mt-2",
                            children: categories.map(function(post, idx) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(tabs_esm/* Tab.Panel */.O.Panel, {
                                    className: classNames("bg-white rounded-xl md:p-3", "focus:outline-none      "),
                                    children: post === null || post === void 0 ? void 0 : post.feature
                                }, idx);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var tradly_home_AnyDevices = (AnyDevices);


/***/ }),

/***/ 96792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tradly_home_Integrations; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Widont.js
var Widont = __webpack_require__(15253);
// EXTERNAL MODULE: ./src/components/home/common.js
var common = __webpack_require__(47262);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.esm.js
var tabs_esm = __webpack_require__(66311);
;// CONCATENATED MODULE: ./src/img/tradly/hero_icons/integrations.svg
var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgIntegrations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 20,
    fill: "#03F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.358 36.46l-2.464-13.577a.46.46 0 00-.229-.32l-6.202-3.45a.458.458 0 00-.26-.055l1.129 14.556-.038.017 7.423 3.33a.462.462 0 00.641-.502zM24.683 22.41l-6.344-3.303a.459.459 0 00-.177-.05l-1.128 14.556 7.46 3.347a.46.46 0 00.189.04V22.41z",
    fill: "#44C868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.162 19.057a.46.46 0 00-.26.056l-6.202 3.45a.46.46 0 00-.228.32L9.007 36.457a.46.46 0 00.642.502l7.382-3.312 1.131-14.59zM31.203 19.058a.46.46 0 00-.177.05l-6.343 3.303v14.59a.459.459 0 00.188-.04l7.46-3.347-1.128-14.556z",
    fill: "#4CE166"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.725 26.996l-.5 2.758 7.411-3.915.172-2.22.029-.368-7.112 3.745z",
    fill: "#FFDB56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.703 24.979l-.067.86-7.412 3.915-1.217 6.704a.46.46 0 00.642.502l7.382-3.312.672-8.67z",
    fill: "#A8EEFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.684 24.23l-6.848-.979-.2 2.588 7.046 10.701v-3.891l-4.205-6.621 4.207.503v-2.3zM37.176 22.29l-2.98-1.656-2.82.659.035.455.14 1.797 5.625-1.254z",
    fill: "#FFBB24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.801 26.773l-.267-3.446-.157-2.034-6.692 2.938v2.3l4.37-1.9 2.746 2.142z",
    fill: "#FFDB56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.358 36.458l-.62-3.41-8.187-9.503.25 3.227 8.397 10.121a.46.46 0 00.16-.435z",
    fill: "#FFBB24"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.712 9c-3.55 0-6.44 2.886-6.44 6.434 0 2.195 1.042 4.551 3.098 7.004a22.021 22.021 0 003.06 3.008.46.46 0 00.564 0 22.021 22.021 0 003.06-3.008c2.056-2.453 3.098-4.809 3.098-7.004 0-3.548-2.89-6.434-6.44-6.434zm2.385 6.434a2.384 2.384 0 01-2.385 2.383 2.384 2.384 0 112.385-2.383z",
    fill: "#FF4A4A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.712 9c-.282 0-.559.018-.83.053 3.16.409 5.608 3.115 5.608 6.381 0 2.195-1.041 4.551-3.097 7.004a23.042 23.042 0 01-2.512 2.552c.322.28.527.439.55.456a.46.46 0 00.563 0 22.021 22.021 0 003.06-3.008c2.056-2.453 3.098-4.809 3.098-7.004 0-3.548-2.89-6.434-6.44-6.434z",
    fill: "#E7343F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.871 36.96l2.774-1.245-2.962-3.066v4.352a.459.459 0 00.188-.04z",
    fill: "#FFDB56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.894 22.881a.46.46 0 00-.23-.32l-.487-.271-5.626 1.255 8.188 9.502-1.845-10.166zM24.683 37v-.46l-7.046-10.701-.603 7.773 7.46 3.347a.46.46 0 00.189.04z",
    fill: "#1EA4E9"
  })));
}
/* harmony default export */ var integrations = ("/_next/static/media/integrations.1d8eb4ea8254e45587c8ee8e5fa28d47.svg");

// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/feature.js
var feature = __webpack_require__(6597);
;// CONCATENATED MODULE: ./src/components/home/tradly-home/Integrations.jsx








function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
var Integrations = function() {
    var ref = (0,react.useState)([
        {
            id: 1,
            buttonTitle: "Payment",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11 9H15C15.2652 9 15.5196 8.89464 15.7071 8.70711C15.8946 8.51957 16 8.26522 16 8C16 7.73478 15.8946 7.48043 15.7071 7.29289C15.5196 7.10536 15.2652 7 15 7H13V6C13 5.73478 12.8946 5.48043 12.7071 5.29289C12.5196 5.10536 12.2652 5 12 5C11.7348 5 11.4804 5.10536 11.2929 5.29289C11.1054 5.48043 11 5.73478 11 6V7C10.2044 7 9.44129 7.31607 8.87868 7.87868C8.31607 8.44129 8 9.20435 8 10C8 10.7956 8.31607 11.5587 8.87868 12.1213C9.44129 12.6839 10.2044 13 11 13H13C13.2652 13 13.5196 13.1054 13.7071 13.2929C13.8946 13.4804 14 13.7348 14 14C14 14.2652 13.8946 14.5196 13.7071 14.7071C13.5196 14.8946 13.2652 15 13 15H9C8.73479 15 8.48043 15.1054 8.2929 15.2929C8.10536 15.4804 8 15.7348 8 16C8 16.2652 8.10536 16.5196 8.2929 16.7071C8.48043 16.8946 8.73479 17 9 17H11V18C11 18.2652 11.1054 18.5196 11.2929 18.7071C11.4804 18.8946 11.7348 19 12 19C12.2652 19 12.5196 18.8946 12.7071 18.7071C12.8946 18.5196 13 18.2652 13 18V17C13.7957 17 14.5587 16.6839 15.1213 16.1213C15.6839 15.5587 16 14.7956 16 14C16 13.2044 15.6839 12.4413 15.1213 11.8787C14.5587 11.3161 13.7957 11 13 11H11C10.7348 11 10.4804 10.8946 10.2929 10.7071C10.1054 10.5196 10 10.2652 10 10C10 9.73478 10.1054 9.48043 10.2929 9.29289C10.4804 9.10536 10.7348 9 11 9ZM12 1C9.82441 1 7.69767 1.64514 5.88873 2.85383C4.07979 4.06253 2.66989 5.78049 1.83733 7.79048C1.00477 9.80047 0.786929 12.0122 1.21137 14.146C1.6358 16.2798 2.68345 18.2398 4.22183 19.7782C5.76021 21.3166 7.72022 22.3642 9.85401 22.7886C11.9878 23.2131 14.1995 22.9952 16.2095 22.1627C18.2195 21.3301 19.9375 19.9202 21.1462 18.1113C22.3549 16.3023 23 14.1756 23 12C23 9.08262 21.8411 6.28473 19.7782 4.22183C17.7153 2.15893 14.9174 1 12 1ZM12 21C10.22 21 8.47992 20.4722 6.99987 19.4832C5.51983 18.4943 4.36628 17.0887 3.68509 15.4442C3.0039 13.7996 2.82567 11.99 3.17294 10.2442C3.5202 8.49836 4.37737 6.89471 5.63604 5.63604C6.89472 4.37737 8.49836 3.5202 10.2442 3.17293C11.99 2.82567 13.7996 3.0039 15.4442 3.68508C17.0887 4.36627 18.4943 5.51983 19.4832 6.99987C20.4722 8.47991 21 10.22 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.387 21 12 21Z"
            }),
            feature: "/docs/paymentgateways"
        },
        {
            id: 2,
            buttonTitle: "Growth",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 20H20V5C20 4.73478 19.8946 4.48043 19.7071 4.29289C19.5196 4.10536 19.2652 4 19 4C18.7348 4 18.4804 4.10536 18.2929 4.29289C18.1054 4.48043 18 4.73478 18 5V20H16V9C16 8.73478 15.8946 8.48043 15.7071 8.29289C15.5196 8.10536 15.2652 8 15 8C14.7348 8 14.4804 8.10536 14.2929 8.29289C14.1054 8.48043 14 8.73478 14 9V20H12V13C12 12.7348 11.8946 12.4804 11.7071 12.2929C11.5196 12.1054 11.2652 12 11 12C10.7348 12 10.4804 12.1054 10.2929 12.2929C10.1054 12.4804 10 12.7348 10 13V20H8V17C8 16.7348 7.89464 16.4804 7.70711 16.2929C7.51957 16.1054 7.26522 16 7 16C6.73478 16 6.48043 16.1054 6.29289 16.2929C6.10536 16.4804 6 16.7348 6 17V20H4V3C4 2.73478 3.89464 2.48043 3.70711 2.29289C3.51957 2.10536 3.26522 2 3 2C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21C22 20.7348 21.8946 20.4804 21.7071 20.2929C21.5196 20.1054 21.2652 20 21 20Z"
            }),
            feature: "/integrations"
        },
        {
            id: 3,
            buttonTitle: "App Deployments",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 13H4C3.73478 13 3.48043 13.1054 3.29289 13.2929C3.10536 13.4804 3 13.7348 3 14V20C3 20.2652 3.10536 20.5196 3.29289 20.7071C3.48043 20.8946 3.73478 21 4 21H10C10.2652 21 10.5196 20.8946 10.7071 20.7071C10.8946 20.5196 11 20.2652 11 20V14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13ZM9 19H5V15H9V19ZM20 3H14C13.7348 3 13.4804 3.10536 13.2929 3.29289C13.1054 3.48043 13 3.73478 13 4V10C13 10.2652 13.1054 10.5196 13.2929 10.7071C13.4804 10.8946 13.7348 11 14 11H20C20.2652 11 20.5196 10.8946 20.7071 10.7071C20.8946 10.5196 21 10.2652 21 10V4C21 3.73478 20.8946 3.48043 20.7071 3.29289C20.5196 3.10536 20.2652 3 20 3ZM19 9H15V5H19V9ZM20 16H18V14C18 13.7348 17.8946 13.4804 17.7071 13.2929C17.5196 13.1054 17.2652 13 17 13C16.7348 13 16.4804 13.1054 16.2929 13.2929C16.1054 13.4804 16 13.7348 16 14V16H14C13.7348 16 13.4804 16.1054 13.2929 16.2929C13.1054 16.4804 13 16.7348 13 17C13 17.2652 13.1054 17.5196 13.2929 17.7071C13.4804 17.8946 13.7348 18 14 18H16V20C16 20.2652 16.1054 20.5196 16.2929 20.7071C16.4804 20.8946 16.7348 21 17 21C17.2652 21 17.5196 20.8946 17.7071 20.7071C17.8946 20.5196 18 20.2652 18 20V18H20C20.2652 18 20.5196 17.8946 20.7071 17.7071C20.8946 17.5196 21 17.2652 21 17C21 16.7348 20.8946 16.4804 20.7071 16.2929C20.5196 16.1054 20.2652 16 20 16ZM10 3H4C3.73478 3 3.48043 3.10536 3.29289 3.29289C3.10536 3.48043 3 3.73478 3 4V10C3 10.2652 3.10536 10.5196 3.29289 10.7071C3.48043 10.8946 3.73478 11 4 11H10C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V4C11 3.73478 10.8946 3.48043 10.7071 3.29289C10.5196 3.10536 10.2652 3 10 3ZM9 9H5V5H9V9Z"
            }),
            feature: "/docs/vercel"
        }, 
    ]), categories = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-7xl mx-auto px-4 sm:px-6 md:px-8 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: integrations,
                    alt: "",
                    className: "p-0"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Caption */.YS, {
                className: "text-color6",
                children: "Integrations"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* BigText */.y8, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Widont/* Widont */.X, {
                    children: "Pre-built integrations for your team."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Paragraph */.nv, {
                children: "Tradly provides a blend of integrations, including native integrations and connectors that open up additional possibilities. Your marketing, product, and other teams can leverage these integrations from day one without investing excessive time in reinventing the wheel"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full px-2 sm:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.Group */.O.Group, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.List */.O.List, {
                        className: "mt-2 flex p-1 items-center gap-7 ",
                        children: categories.map(function(category) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab */.O, {
                                className: function(param) {
                                    var selected = param.selected;
                                    return classNames("w-[96px] py-2.5 text-sm leading-5 font-medium rounded-lg flex flex-col justify-center items-center gap-6  group outline-none ", selected ? "  transition duration-500 text-color6" : "text-gray-300  hover:text-gray-400");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: category.feature,
                                    className: " flex flex-col justify-center items-center gap-6 ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-12 w-12",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            children: category.icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "",
                                            children: category.buttonTitle
                                        })
                                    ]
                                })
                            }, category);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var tradly_home_Integrations = (Integrations);


/***/ }),

/***/ 93968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tradly_home_Studio; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Widont.js
var Widont = __webpack_require__(15253);
// EXTERNAL MODULE: ./src/components/home/common.js
var common = __webpack_require__(47262);
;// CONCATENATED MODULE: ./src/img/tradly/hero_icons/bespoke.svg
var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgBespoke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 20,
    fill: "#22A0DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.43 15.355h-9.556v-2.722c0-.902.73-1.633 1.633-1.633h6.29c.902 0 1.633.731 1.633 1.633v2.722z",
    fill: "url(#bespoke_svg__paint0_linear_1242_149)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.975 15.355h-9.557v-2.722c0-.902.731-1.633 1.633-1.633h6.29c.902 0 1.634.731 1.634 1.633v2.722z",
    fill: "url(#bespoke_svg__paint1_linear_1242_149)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.374 14.1v-1.467c0-.902-.731-1.633-1.633-1.633h-6.29c-.902 0-1.634.731-1.634 1.633v17.634a2.327 2.327 0 002.327 2.326h17.822a2.327 2.327 0 002.327-2.326v-13.13a2.327 2.327 0 00-2.327-2.326h-9.881a.71.71 0 01-.71-.711z",
    fill: "url(#bespoke_svg__paint2_linear_1242_149)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.572 18.011h-.56a.582.582 0 01-.582-.582v-.56c0-.321.26-.582.582-.582h.56c.322 0 .582.26.582.582v.56c0 .322-.26.582-.582.582z",
    fill: "url(#bespoke_svg__paint3_linear_1242_149)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.77 18.011h-.56a.582.582 0 01-.583-.582v-.56c0-.321.261-.582.582-.582h.56c.322 0 .583.26.583.582v.56c0 .322-.261.582-.582.582z",
    fill: "url(#bespoke_svg__paint4_linear_1242_149)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.968 18.011h-.56a.582.582 0 01-.582-.582v-.56c0-.321.26-.582.581-.582h.56c.322 0 .583.26.583.582v.56c0 .322-.26.582-.582.582z",
    fill: "url(#bespoke_svg__paint5_linear_1242_149)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.966 32.593a2.327 2.327 0 002.326-2.326v-8.473l-2.984-2.985a2.32 2.32 0 00-1.751-.795h-2.729l-3.17-3.204H15.818v15.432a2.351 2.351 0 002.351 2.351h17.798z",
    fill: "url(#bespoke_svg__paint6_linear_1242_149)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.817 27.694v2.573a2.327 2.327 0 002.326 2.327h17.823a2.327 2.327 0 002.326-2.327v-2.573H15.817z",
    fill: "url(#bespoke_svg__paint7_linear_1242_149)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.023 18.558h-9.557v-2.722c0-.902.731-1.633 1.633-1.633h6.29c.902 0 1.634.731 1.634 1.633v2.722z",
    fill: "url(#bespoke_svg__paint8_linear_1242_149)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.567 18.558H16.01v-2.722c0-.902.731-1.633 1.633-1.633h6.29c.903 0 1.634.731 1.634 1.633v2.722z",
    fill: "url(#bespoke_svg__paint9_linear_1242_149)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.965 17.303v-1.467c0-.902-.73-1.633-1.633-1.633h-6.29c-.902 0-1.633.731-1.633 1.633V33.47a2.327 2.327 0 002.326 2.327h17.822a2.327 2.327 0 002.327-2.327V20.34a2.327 2.327 0 00-2.327-2.326h-9.88a.71.71 0 01-.712-.711z",
    fill: "url(#bespoke_svg__paint10_linear_1242_149)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.165 21.214h-.56a.582.582 0 01-.582-.582v-.56c0-.321.26-.582.581-.582h.56c.322 0 .582.26.582.582v.56c0 .322-.26.582-.581.582z",
    fill: "url(#bespoke_svg__paint11_linear_1242_149)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.363 21.214h-.56a.582.582 0 01-.582-.582v-.56c0-.321.26-.582.582-.582h.56c.322 0 .582.26.582.582v.56c0 .322-.26.582-.582.582z",
    fill: "url(#bespoke_svg__paint12_linear_1242_149)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.562 21.214h-.56a.582.582 0 01-.583-.582v-.56c0-.321.26-.582.582-.582h.56c.322 0 .583.26.583.582v.56c0 .322-.261.582-.582.582z",
    fill: "url(#bespoke_svg__paint13_linear_1242_149)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.558 35.796a2.327 2.327 0 002.327-2.326v-8.473L32.9 22.012a2.32 2.32 0 00-1.75-.795h-2.73l-3.17-3.203H13.41v15.431a2.351 2.351 0 002.351 2.351h17.798z",
    fill: "url(#bespoke_svg__paint14_linear_1242_149)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.41 30.898v2.572a2.327 2.327 0 002.326 2.327h17.822a2.327 2.327 0 002.327-2.327v-2.572H13.409z",
    fill: "url(#bespoke_svg__paint15_linear_1242_149)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.613 21.761h-9.556V19.04c0-.902.73-1.633 1.633-1.633h6.29c.902 0 1.633.731 1.633 1.633v2.722z",
    fill: "url(#bespoke_svg__paint16_linear_1242_149)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.158 21.761H13.6V19.04c0-.902.731-1.633 1.633-1.633h6.29c.903 0 1.634.731 1.634 1.633v2.722z",
    fill: "url(#bespoke_svg__paint17_linear_1242_149)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.557 20.506V19.04c0-.902-.731-1.633-1.633-1.633h-6.29c-.903 0-1.634.731-1.634 1.633v17.634A2.327 2.327 0 0013.327 39h17.822a2.327 2.327 0 002.326-2.327v-13.13a2.327 2.327 0 00-2.326-2.326h-9.882a.71.71 0 01-.71-.71z",
    fill: "url(#bespoke_svg__paint18_linear_1242_149)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.756 24.417h-.56a.582.582 0 01-.583-.582v-.56c0-.321.26-.582.582-.582h.56c.322 0 .582.26.582.582v.56c0 .322-.26.582-.581.582z",
    fill: "url(#bespoke_svg__paint19_linear_1242_149)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.954 24.417h-.56a.582.582 0 01-.582-.582v-.56c0-.321.26-.582.581-.582h.56c.322 0 .583.26.583.582v.56c0 .322-.261.582-.582.582z",
    fill: "url(#bespoke_svg__paint20_linear_1242_149)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.151 24.417h-.56a.582.582 0 01-.582-.582v-.56c0-.321.26-.582.582-.582h.56c.322 0 .582.26.582.582v.56c0 .322-.26.582-.582.582z",
    fill: "url(#bespoke_svg__paint21_linear_1242_149)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11 34.1v2.573A2.327 2.327 0 0013.327 39h17.822a2.327 2.327 0 002.326-2.327v-2.572H11z",
    fill: "url(#bespoke_svg__paint22_linear_1242_149)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint0_linear_1242_149",
    x1: 25.652,
    y1: 11.907,
    x2: 25.652,
    y2: 15.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint1_linear_1242_149",
    x1: 23.196,
    y1: 11.907,
    x2: 23.196,
    y2: 15.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90CC1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint2_linear_1242_149",
    x1: 23.336,
    y1: 12.118,
    x2: 33.4,
    y2: 43.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint3_linear_1242_149",
    x1: 31.101,
    y1: 17.003,
    x2: 31.888,
    y2: 17.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint4_linear_1242_149",
    x1: 33.298,
    y1: 17.003,
    x2: 34.086,
    y2: 17.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint5_linear_1242_149",
    x1: 35.496,
    y1: 17.003,
    x2: 36.284,
    y2: 17.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint6_linear_1242_149",
    x1: 26.68,
    y1: 23.724,
    x2: 35.092,
    y2: 2.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B799D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#096380",
    stopOpacity: 0.365
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#084F67",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint7_linear_1242_149",
    x1: 27.055,
    y1: 29.751,
    x2: 27.055,
    y2: 34.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B799D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#096380",
    stopOpacity: 0.365
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#084F67",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint8_linear_1242_149",
    x1: 23.244,
    y1: 15.11,
    x2: 23.244,
    y2: 18.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint9_linear_1242_149",
    x1: 20.789,
    y1: 15.11,
    x2: 20.789,
    y2: 18.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48B2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint10_linear_1242_149",
    x1: 14.987,
    y1: 17.246,
    x2: 29.421,
    y2: 31.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76E2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint11_linear_1242_149",
    x1: 28.693,
    y1: 20.206,
    x2: 29.481,
    y2: 20.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint12_linear_1242_149",
    x1: 30.892,
    y1: 20.206,
    x2: 31.679,
    y2: 20.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint13_linear_1242_149",
    x1: 33.09,
    y1: 20.206,
    x2: 33.878,
    y2: 20.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint14_linear_1242_149",
    x1: 24.381,
    y1: 36.02,
    x2: 24.852,
    y2: 17.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#8FC5E9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#56A4C8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#2D8DB1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#147EA2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint15_linear_1242_149",
    x1: 24.647,
    y1: 32.954,
    x2: 24.647,
    y2: 37.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#8FC5E9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#56A4C8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#2D8DB1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#147EA2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint16_linear_1242_149",
    x1: 20.835,
    y1: 18.314,
    x2: 20.835,
    y2: 21.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint17_linear_1242_149",
    x1: 18.379,
    y1: 18.314,
    x2: 18.379,
    y2: 21.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint18_linear_1242_149",
    x1: 12.579,
    y1: 20.449,
    x2: 27.012,
    y2: 34.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint19_linear_1242_149",
    x1: 26.284,
    y1: 23.409,
    x2: 27.072,
    y2: 24.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF637B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint20_linear_1242_149",
    x1: 28.482,
    y1: 23.409,
    x2: 29.27,
    y2: 24.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF637B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint21_linear_1242_149",
    x1: 30.68,
    y1: 23.409,
    x2: 31.468,
    y2: 24.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF637B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint22_linear_1242_149",
    x1: 22.238,
    y1: 36.157,
    x2: 22.238,
    y2: 40.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })))));
}
/* harmony default export */ var bespoke = ("/_next/static/media/bespoke.ef99c89ef5e5a2a4fd9c2d6d87aaa91a.svg");

// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/feature.js
var feature = __webpack_require__(6597);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./src/Shared/Button.jsx
var Button = __webpack_require__(36532);
;// CONCATENATED MODULE: ./src/components/home/tradly-home/Studio.jsx











function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
var Studio = function() {
    var ref = (0,react.useState)([
        {
            id: 1,
            buttonTitle: "Styling",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.4199 15.54C7.23365 15.7274 7.12911 15.9808 7.12911 16.245C7.12911 16.5092 7.23365 16.7627 7.4199 16.95C7.51286 17.0437 7.62346 17.1181 7.74532 17.1689C7.86718 17.2197 7.99789 17.2458 8.1299 17.2458C8.26191 17.2458 8.39262 17.2197 8.51448 17.1689C8.63633 17.1181 8.74694 17.0437 8.8399 16.95C9.02615 16.7627 9.13069 16.5092 9.13069 16.245C9.13069 15.9808 9.02615 15.7274 8.8399 15.54C8.74694 15.4463 8.63633 15.3719 8.51448 15.3211C8.39262 15.2704 8.26191 15.2442 8.1299 15.2442C7.99789 15.2442 7.86718 15.2704 7.74532 15.3211C7.62346 15.3719 7.51286 15.4463 7.4199 15.54ZM7.4199 7.05002C7.23365 7.23738 7.12911 7.49083 7.12911 7.75502C7.12911 8.0192 7.23365 8.27265 7.4199 8.46002C7.51286 8.55375 7.62346 8.62814 7.74532 8.67891C7.86718 8.72968 7.99789 8.75582 8.1299 8.75582C8.26191 8.75582 8.39262 8.72968 8.51448 8.67891C8.63633 8.62814 8.74694 8.55375 8.8399 8.46002C9.02615 8.27265 9.13069 8.0192 9.13069 7.75502C9.13069 7.49083 9.02615 7.23738 8.8399 7.05002C8.74694 6.95629 8.63633 6.88189 8.51448 6.83113C8.39262 6.78036 8.26191 6.75422 8.1299 6.75422C7.99789 6.75422 7.86718 6.78036 7.74532 6.83113C7.62346 6.88189 7.51286 6.95629 7.4199 7.05002ZM12.3699 17.05C12.1721 17.05 11.9788 17.1087 11.8143 17.2185C11.6499 17.3284 11.5217 17.4846 11.446 17.6673C11.3703 17.8501 11.3505 18.0511 11.3891 18.2451C11.4277 18.4391 11.5229 18.6173 11.6628 18.7571C11.8026 18.897 11.9808 18.9922 12.1748 19.0308C12.3688 19.0694 12.5699 19.0496 12.7526 18.9739C12.9353 18.8982 13.0915 18.77 13.2014 18.6056C13.3112 18.4411 13.3699 18.2478 13.3699 18.05C13.3767 17.9145 13.3558 17.7791 13.3086 17.652C13.2614 17.5248 13.1888 17.4086 13.0953 17.3104C13.0017 17.2121 12.8892 17.134 12.7645 17.0806C12.6398 17.0273 12.5055 16.9998 12.3699 17V17.05ZM6.3699 11.05C6.17212 11.05 5.97878 11.1087 5.81433 11.2185C5.64988 11.3284 5.52171 11.4846 5.44602 11.6673C5.37033 11.8501 5.35053 12.0511 5.38911 12.2451C5.4277 12.4391 5.52294 12.6173 5.66279 12.7571C5.80264 12.897 5.98083 12.9922 6.17481 13.0308C6.36879 13.0694 6.56986 13.0496 6.75258 12.9739C6.93531 12.8982 7.09149 12.77 7.20137 12.6056C7.31125 12.4411 7.3699 12.2478 7.3699 12.05C7.37668 11.9145 7.35583 11.7791 7.30862 11.652C7.26141 11.5248 7.18883 11.4086 7.09529 11.3104C7.00174 11.2121 6.8892 11.134 6.76449 11.0806C6.63979 11.0273 6.50554 10.9998 6.3699 11V11.05ZM12.3699 5.05002C12.1721 5.05002 11.9788 5.10867 11.8143 5.21855C11.6499 5.32843 11.5217 5.48461 11.446 5.66733C11.3703 5.85006 11.3505 6.05113 11.3891 6.24511C11.4277 6.43909 11.5229 6.61727 11.6628 6.75712C11.8026 6.89698 11.9808 6.99222 12.1748 7.0308C12.3688 7.06939 12.5699 7.04958 12.7526 6.9739C12.9353 6.89821 13.0915 6.77004 13.2014 6.60559C13.3112 6.44114 13.3699 6.2478 13.3699 6.05002C13.3767 5.91455 13.3558 5.77912 13.3086 5.65196C13.2614 5.5248 13.1888 5.40858 13.0953 5.31036C13.0017 5.21214 12.8892 5.13398 12.7645 5.08062C12.6398 5.02727 12.5055 4.99985 12.3699 5.00002V5.05002ZM15.9099 7.10002C15.7695 7.23963 15.6736 7.4178 15.6346 7.61195C15.5955 7.80609 15.6149 8.00746 15.6905 8.19053C15.766 8.37361 15.8941 8.53014 16.0587 8.64028C16.2233 8.75042 16.4169 8.80922 16.6149 8.80922C16.8129 8.80922 17.0065 8.75042 17.1711 8.64028C17.3357 8.53014 17.4638 8.37361 17.5393 8.19053C17.6149 8.00746 17.6343 7.80609 17.5952 7.61195C17.5562 7.4178 17.4603 7.23963 17.3199 7.10002C17.1392 6.90697 16.8895 6.79334 16.6252 6.78397C16.361 6.7746 16.1038 6.87025 15.9099 7.05002V7.10002ZM22.2099 7.10002C21.2956 5.27231 19.8903 3.73544 18.1515 2.66172C16.4127 1.588 14.4091 1.0199 12.3655 1.02112C10.3219 1.02234 8.31902 1.59284 6.58148 2.66863C4.84395 3.74443 3.44045 5.28298 2.52838 7.11178C1.61631 8.94057 1.23172 10.9873 1.41774 13.0224C1.60377 15.0576 2.35305 17.0006 3.58157 18.6338C4.81008 20.2669 6.46926 21.5255 8.37304 22.2684C10.2768 23.0114 12.3499 23.2093 14.3599 22.84C14.8653 22.7449 15.3468 22.55 15.776 22.2667C16.2053 21.9834 16.5737 21.6174 16.8599 21.19C17.1682 20.7254 17.381 20.2041 17.4857 19.6564C17.5905 19.1087 17.5851 18.5456 17.4699 18C17.4069 17.6703 17.3735 17.3357 17.3699 17C17.3743 16.031 17.6602 15.0841 18.1928 14.2745C18.7254 13.465 19.4817 12.8276 20.3699 12.44C20.8488 12.2256 21.2786 11.9153 21.6329 11.5284C21.9872 11.1414 22.2585 10.6859 22.4299 10.19C22.6033 9.6833 22.6732 9.14693 22.6354 8.6127C22.5976 8.07847 22.4529 7.55728 22.2099 7.08002V7.10002ZM20.5099 9.54002C20.4246 9.77933 20.2921 9.99911 20.1203 10.1863C19.9486 10.3736 19.741 10.5244 19.5099 10.63C18.2799 11.1806 17.2349 12.0746 16.5006 13.2045C15.7662 14.3345 15.3736 15.6524 15.3699 17C15.3714 17.4701 15.4183 17.9389 15.5099 18.4C15.571 18.6818 15.575 18.973 15.5218 19.2564C15.4685 19.5397 15.3591 19.8096 15.1999 20.05C15.0652 20.2604 14.888 20.4403 14.6796 20.5781C14.4712 20.7159 14.2362 20.8085 13.9899 20.85C13.4558 20.9504 12.9134 21.0006 12.3699 21C11.1641 21.0006 9.97041 20.7589 8.85982 20.2892C7.74923 19.8195 6.74435 19.1314 5.90486 18.2658C5.06537 17.4002 4.40838 16.3747 3.97291 15.2502C3.53745 14.1258 3.33238 12.9253 3.3699 11.72C3.44751 9.47281 4.3589 7.33497 5.92653 5.72298C7.49415 4.11099 9.60573 3.1403 11.8499 3.00002H12.3599C14.0357 3.00044 15.678 3.4687 17.102 4.35208C18.526 5.23546 19.6751 6.49887 20.4199 8.00002C20.6491 8.475 20.6815 9.0213 20.5099 9.52002V9.54002ZM12.3699 11C12.1721 11 11.9788 11.0587 11.8143 11.1685C11.6499 11.2784 11.5217 11.4346 11.446 11.6173C11.3703 11.8001 11.3505 12.0011 11.3891 12.1951C11.4277 12.3891 11.5229 12.5673 11.6628 12.7071C11.8026 12.847 11.9808 12.9422 12.1748 12.9808C12.3688 13.0194 12.5699 12.9996 12.7526 12.9239C12.9353 12.8482 13.0915 12.72 13.2014 12.5556C13.3112 12.3911 13.3699 12.1978 13.3699 12C13.3699 11.7348 13.2645 11.4804 13.077 11.2929C12.8895 11.1054 12.6351 11 12.3699 11Z"
            }),
            feature: feature/* feature1 */.m
        },
        {
            id: 2,
            buttonTitle: "Features",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 8.5C15.3078 8.5 14.6311 8.70527 14.0555 9.08986C13.4799 9.47444 13.0313 10.0211 12.7664 10.6606C12.5015 11.3001 12.4322 12.0039 12.5673 12.6828C12.7023 13.3617 13.0356 13.9854 13.5251 14.4749C14.0146 14.9644 14.6383 15.2977 15.3172 15.4327C15.9961 15.5678 16.6999 15.4985 17.3394 15.2336C17.9789 14.9687 18.5256 14.5201 18.9101 13.9445C19.2947 13.3689 19.5 12.6922 19.5 12C19.5 11.0717 19.1313 10.1815 18.4749 9.52513C17.8185 8.86875 16.9283 8.5 16 8.5ZM16 13.5C15.7033 13.5 15.4133 13.412 15.1666 13.2472C14.92 13.0824 14.7277 12.8481 14.6142 12.574C14.5006 12.2999 14.4709 11.9983 14.5288 11.7074C14.5867 11.4164 14.7296 11.1491 14.9393 10.9393C15.1491 10.7296 15.4164 10.5867 15.7074 10.5288C15.9983 10.4709 16.2999 10.5006 16.574 10.6142C16.8481 10.7277 17.0824 10.92 17.2472 11.1666C17.412 11.4133 17.5 11.7033 17.5 12C17.5 12.3978 17.342 12.7794 17.0607 13.0607C16.7794 13.342 16.3978 13.5 16 13.5ZM16 5H8C6.14348 5 4.36301 5.7375 3.05025 7.05025C1.7375 8.36301 1 10.1435 1 12C1 13.8565 1.7375 15.637 3.05025 16.9497C4.36301 18.2625 6.14348 19 8 19H16C17.8565 19 19.637 18.2625 20.9497 16.9497C22.2625 15.637 23 13.8565 23 12C23 10.1435 22.2625 8.36301 20.9497 7.05025C19.637 5.7375 17.8565 5 16 5ZM16 17H8C6.67392 17 5.40215 16.4732 4.46447 15.5355C3.52678 14.5979 3 13.3261 3 12C3 10.6739 3.52678 9.40215 4.46447 8.46447C5.40215 7.52678 6.67392 7 8 7H16C17.3261 7 18.5979 7.52678 19.5355 8.46447C20.4732 9.40215 21 10.6739 21 12C21 13.3261 20.4732 14.5979 19.5355 15.5355C18.5979 16.4732 17.3261 17 16 17Z"
            }),
            feature: feature/* feature1 */.m
        },
        {
            id: 3,
            buttonTitle: "Branding",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 9.6699C21.9368 9.48699 21.822 9.32633 21.6693 9.2074C21.5167 9.08848 21.3328 9.0164 21.14 8.9999L15.45 8.1699L12.9 2.9999C12.8181 2.83083 12.6902 2.68824 12.5311 2.58847C12.3719 2.48871 12.1878 2.43579 12 2.43579C11.8121 2.43579 11.6281 2.48871 11.4689 2.58847C11.3097 2.68824 11.1819 2.83083 11.1 2.9999L8.54998 8.1599L2.85998 8.9999C2.6749 9.02621 2.5009 9.10386 2.35773 9.22406C2.21455 9.34425 2.10794 9.50218 2.04998 9.6799C1.99692 9.85358 1.99216 10.0384 2.03621 10.2146C2.08025 10.3908 2.17144 10.5516 2.29998 10.6799L6.42998 14.6799L5.42998 20.3599C5.3896 20.5483 5.40453 20.7444 5.47296 20.9245C5.54139 21.1047 5.66041 21.2612 5.81571 21.3753C5.971 21.4894 6.15595 21.5562 6.34831 21.5676C6.54066 21.5791 6.73224 21.5347 6.89998 21.4399L12 18.7699L17.1 21.4399C17.2403 21.5191 17.3988 21.5604 17.56 21.5599C17.7718 21.5607 17.9784 21.4941 18.15 21.3699C18.3051 21.2588 18.4252 21.1055 18.4961 20.9284C18.567 20.7512 18.5857 20.5574 18.55 20.3699L17.55 14.6899L21.68 10.6899C21.8244 10.5676 21.9311 10.4068 21.9877 10.2262C22.0444 10.0457 22.0486 9.85278 22 9.6699ZM15.85 13.6699C15.7342 13.7823 15.6474 13.9211 15.5969 14.0743C15.5464 14.2275 15.5337 14.3907 15.56 14.5499L16.28 18.7499L12.52 16.7499C12.3738 16.6776 12.213 16.64 12.05 16.64C11.8869 16.64 11.7261 16.6776 11.58 16.7499L7.81998 18.7499L8.53998 14.5499C8.56622 14.3907 8.55354 14.2275 8.50305 14.0743C8.45255 13.9211 8.36572 13.7823 8.24998 13.6699L5.24998 10.6699L9.45998 10.0599C9.62198 10.0374 9.77598 9.97544 9.90848 9.87955C10.041 9.78366 10.1479 9.65674 10.22 9.5099L12 5.6999L13.88 9.5199C13.952 9.66674 14.059 9.79366 14.1915 9.88955C14.324 9.98544 14.478 10.0474 14.64 10.0699L18.85 10.6799L15.85 13.6699Z"
            }),
            feature: feature/* feature1 */.m
        },
        {
            id: 4,
            buttonTitle: "Contents ",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
            }),
            feature: feature/* feature1 */.m
        }, 
    ]), categories = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-7xl mx-auto px-4 sm:px-6 md:px-8 space-y-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: bespoke,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Caption */.YS, {
                        className: "text-color8",
                        children: "Custom Development"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* BigText */.y8, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Widont/* Widont */.X, {
                    children: "Require a be-spoke solution from us?"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Paragraph */.nv, {
                children: "Let's work with your design agency, and our partner development agencies to build front end apps from scratch. Full flexibility and planned timeline for a custom big project."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                title: "Contact Us",
                url: "https://tradly.app/support"
            })
        ]
    });
};
/* harmony default export */ var tradly_home_Studio = (Studio);


/***/ }),

/***/ 9936:
/***/ (function(module) {

"use strict";

module.exports = {
    categories: [
        {
            id: 1837,
            parent: 0,
            type: "listings",
            active: true,
            image_path: "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/25723/77bb555c-bf89-42f9-b81d-344a23291814.jpeg",
            order_by: 1,
            sub_category: [],
            name: "ADIDAS",
            hierarchy: [
                {
                    id: 1837,
                    name: "ADIDAS",
                    level: 1
                }, 
            ]
        },
        {
            id: 1839,
            parent: 0,
            type: "listings",
            active: true,
            image_path: "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/61556/63e3c33e-ba29-43cf-8683-ad680ce423bf.jpeg",
            order_by: 1,
            sub_category: [],
            name: "NIKE",
            hierarchy: [
                {
                    id: 1839,
                    name: "NIKE",
                    level: 1
                }, 
            ]
        },
        {
            id: 1838,
            parent: 0,
            type: "listings",
            active: true,
            image_path: "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/48553/0177d7c3-5a7f-4df6-983e-07c0079a73be.png",
            order_by: 2,
            sub_category: [],
            name: "AIR JORDAN",
            hierarchy: [
                {
                    id: 1838,
                    name: "AIR JORDAN",
                    level: 1
                }, 
            ]
        }, 
    ],
    home_page_data: {
        promo_banners: [
            {
                image_path: "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/49029/428def36-6936-493b-b242-a546ae46a4f1.jpeg",
                type: "general",
                content_id: 0,
                value: ""
            },
            {
                image_path: "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/77784/18ef494c-c03c-47a4-a5e8-a8312b1c1afb.jpeg",
                type: "general",
                content_id: 0,
                value: ""
            }, 
        ],
        categories: [
            {
                id: 1837,
                parent: 0,
                type: "listings",
                active: true,
                image_path: "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/25723/77bb555c-bf89-42f9-b81d-344a23291814.jpeg",
                order_by: 1,
                sub_category: [],
                name: "ADIDAS",
                hierarchy: [
                    {
                        id: 1837,
                        name: "ADIDAS",
                        level: 1
                    }, 
                ]
            },
            {
                id: 1839,
                parent: 0,
                type: "listings",
                active: true,
                image_path: "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/61556/63e3c33e-ba29-43cf-8683-ad680ce423bf.jpeg",
                order_by: 1,
                sub_category: [],
                name: "NIKE",
                hierarchy: [
                    {
                        id: 1839,
                        name: "NIKE",
                        level: 1
                    }, 
                ]
            },
            {
                id: 1838,
                parent: 0,
                type: "listings",
                active: true,
                image_path: "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/48553/0177d7c3-5a7f-4df6-983e-07c0079a73be.png",
                order_by: 2,
                sub_category: [],
                name: "AIR JORDAN",
                hierarchy: [
                    {
                        id: 1838,
                        name: "AIR JORDAN",
                        level: 1
                    }, 
                ]
            }, 
        ],
        client_version: {
            android: null,
            ios: null
        },
        collections: [
            {
                id: "sdc-3",
                scope_type: 4,
                view_type: "horizontal",
                background_color: "#FFFF",
                background_image: "https://firebasestorage.googleapis.com/v0/b/tradly-android.appspot.com/o/flower-garland-decoration-toran-for-happy-diwali-vector-17918107.jpg?alt=media&token=b854d543-eec1-4949-a3bf-e107a77ccd3b",
                title: "Latest Sneakers",
                listings: [
                    {
                        id: 518,
                        account_id: 223,
                        list_price: {
                            amount: 710,
                            currency: "DKK",
                            formatted: "kr710"
                        },
                        category_id: [
                            1838
                        ],
                        currency_id: 246,
                        offer_percent: 0,
                        stock: 30,
                        shipping_charges: {
                            amount: 0,
                            currency: "DKK",
                            formatted: "kr0"
                        },
                        images: [
                            "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/23625/9456d5c5-3de2-4b52-8e74-0089c76287d4.png", 
                        ],
                        offer_price: {
                            amount: 710,
                            currency: "DKK",
                            formatted: "kr710"
                        },
                        location: {},
                        type: "listings",
                        sold: false,
                        active: true,
                        status: 2,
                        created_at: 1634748171,
                        start_at: 1634748171,
                        end_at: 1634748171,
                        likes: 0,
                        max_quantity: 20,
                        account: {
                            id: 223,
                            name: "Angela",
                            location: {},
                            unique_name: "",
                            description: "I own special edition sneakers (Yeez, Air Jordan) ",
                            total_followers: 1,
                            total_listings: 7,
                            images: [
                                "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/42917/a25fe9b4-91d1-4f8d-b2d5-0a071020fb1b.png", 
                            ],
                            type: "accounts",
                            active: true,
                            status: 2,
                            following: false,
                            user: {
                                email_verified: true,
                                blocked: false,
                                id: "6d49f2a3-0b10-44bc-b46c-d804001ffec9",
                                first_name: "Angela",
                                last_name: "M",
                                profile_pic: "",
                                email: "jk@istrata.co",
                                mobile: "",
                                dial_code: "",
                                created_at: 1634373500,
                                updated_at: 1634386699
                            },
                            category_id: []
                        },
                        distance: 0,
                        in_cart: false,
                        liked: false,
                        title: "Air Jordan 1 Mid SE",
                        description: "Washed denim and suede make this classic Air Jordan 1 Mid SE tough to beat. The materials are inspired by the rugged look and texture of workwear."
                    },
                    {
                        id: 517,
                        account_id: 223,
                        list_price: {
                            amount: 710,
                            currency: "DKK",
                            formatted: "kr710"
                        },
                        category_id: [
                            1838
                        ],
                        currency_id: 246,
                        offer_percent: 0,
                        stock: 25,
                        shipping_charges: {
                            amount: 0,
                            currency: "DKK",
                            formatted: "kr0"
                        },
                        images: [
                            "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/70844/c748cf5d-9f22-4743-8967-818c3162ac10.png", 
                        ],
                        offer_price: {
                            amount: 710,
                            currency: "DKK",
                            formatted: "kr710"
                        },
                        location: {},
                        type: "listings",
                        sold: false,
                        active: true,
                        status: 2,
                        created_at: 1634747994,
                        start_at: 1634747994,
                        end_at: 1634747994,
                        likes: 0,
                        max_quantity: 20,
                        account: {
                            id: 223,
                            name: "Angela",
                            location: {},
                            unique_name: "",
                            description: "I own special edition sneakers (Yeez, Air Jordan) ",
                            total_followers: 1,
                            total_listings: 7,
                            images: [
                                "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/42917/a25fe9b4-91d1-4f8d-b2d5-0a071020fb1b.png", 
                            ],
                            type: "accounts",
                            active: true,
                            status: 2,
                            following: false,
                            user: {
                                email_verified: true,
                                blocked: false,
                                id: "6d49f2a3-0b10-44bc-b46c-d804001ffec9",
                                first_name: "Angela",
                                last_name: "M",
                                profile_pic: "",
                                email: "jk@istrata.co",
                                mobile: "",
                                dial_code: "",
                                created_at: 1634373500,
                                updated_at: 1634386699
                            },
                            category_id: []
                        },
                        distance: 0,
                        in_cart: false,
                        liked: false,
                        title: "Air Jordan 1 High OG",
                        description: "This Air Jordan 1 High OG brings back the classic from 1985. High-end leather maintains the classic look, while time-tested cushioning keeps you comfortable on the go."
                    },
                    {
                        id: 516,
                        account_id: 223,
                        list_price: {
                            amount: 510,
                            currency: "DKK",
                            formatted: "kr510"
                        },
                        category_id: [
                            1838
                        ],
                        currency_id: 246,
                        offer_percent: 0,
                        stock: 20,
                        shipping_charges: {
                            amount: 0,
                            currency: "DKK",
                            formatted: "kr0"
                        },
                        images: [
                            "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/61954/ccdfb1cd-e650-43f0-ba33-8e25a4db7b49.png", 
                        ],
                        offer_price: {
                            amount: 510,
                            currency: "DKK",
                            formatted: "kr510"
                        },
                        location: {},
                        type: "listings",
                        sold: false,
                        active: true,
                        status: 2,
                        created_at: 1634747770,
                        start_at: 1634747770,
                        end_at: 1634747770,
                        likes: 0,
                        max_quantity: 20,
                        account: {
                            id: 223,
                            name: "Angela",
                            location: {},
                            unique_name: "",
                            description: "I own special edition sneakers (Yeez, Air Jordan) ",
                            total_followers: 1,
                            total_listings: 7,
                            images: [
                                "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/42917/a25fe9b4-91d1-4f8d-b2d5-0a071020fb1b.png", 
                            ],
                            type: "accounts",
                            active: true,
                            status: 2,
                            following: false,
                            user: {
                                email_verified: true,
                                blocked: false,
                                id: "6d49f2a3-0b10-44bc-b46c-d804001ffec9",
                                first_name: "Angela",
                                last_name: "M",
                                profile_pic: "",
                                email: "jk@istrata.co",
                                mobile: "",
                                dial_code: "",
                                created_at: 1634373500,
                                updated_at: 1634386699
                            },
                            category_id: []
                        },
                        distance: 0,
                        in_cart: false,
                        liked: false,
                        title: "Air Jordan 1 Hi FlyEase",
                        description: "The Air Jordan 1 Hi FlyEase gives you a quick way to get into your sneakers while maintaining the timeless appeal of the original.Its collar unzips and the top folds open to create a wide entry, making one of the most iconic shoes of all time easier than ever to get on."
                    },
                    {
                        id: 515,
                        account_id: 223,
                        list_price: {
                            amount: 410,
                            currency: "DKK",
                            formatted: "kr410"
                        },
                        category_id: [
                            1838
                        ],
                        currency_id: 246,
                        offer_percent: 0,
                        stock: 15,
                        shipping_charges: {
                            amount: 0,
                            currency: "DKK",
                            formatted: "kr0"
                        },
                        images: [
                            "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/34110/2ad0567c-def0-41d2-8e61-5af3c79715f3.png", 
                        ],
                        offer_price: {
                            amount: 410,
                            currency: "DKK",
                            formatted: "kr410"
                        },
                        location: {},
                        type: "listings",
                        sold: false,
                        active: true,
                        status: 2,
                        created_at: 1634747576,
                        start_at: 1634747576,
                        end_at: 1634747576,
                        likes: 0,
                        max_quantity: 20,
                        account: {
                            id: 223,
                            name: "Angela",
                            location: {},
                            unique_name: "",
                            description: "I own special edition sneakers (Yeez, Air Jordan) ",
                            total_followers: 1,
                            total_listings: 7,
                            images: [
                                "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/42917/a25fe9b4-91d1-4f8d-b2d5-0a071020fb1b.png", 
                            ],
                            type: "accounts",
                            active: true,
                            status: 2,
                            following: false,
                            user: {
                                email_verified: true,
                                blocked: false,
                                id: "6d49f2a3-0b10-44bc-b46c-d804001ffec9",
                                first_name: "Angela",
                                last_name: "M",
                                profile_pic: "",
                                email: "jk@istrata.co",
                                mobile: "",
                                dial_code: "",
                                created_at: 1634373500,
                                updated_at: 1634386699
                            },
                            category_id: []
                        },
                        distance: 0,
                        in_cart: false,
                        liked: false,
                        title: "Air Jordan XXXV",
                        description: "The lighter the shoe, the less weight to carry, the faster players can go. Evolving from last year's release, the Air Jordan XXXV features a stabilising Eclipse plate 2.0, visible Zoom Air cushioning and stitched-in Flightwire cables that help lock you in when you lace up. Lightweight and responsive, it's designed to help players get the most from their power and athleticism.\n"
                    },
                    {
                        id: 512,
                        account_id: 223,
                        list_price: {
                            amount: 510,
                            currency: "DKK",
                            formatted: "kr510"
                        },
                        category_id: [
                            1838
                        ],
                        currency_id: 246,
                        offer_percent: 0,
                        stock: 5,
                        shipping_charges: {
                            amount: 0,
                            currency: "DKK",
                            formatted: "kr0"
                        },
                        images: [
                            "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/14810/7670985c-644f-4e65-ae3a-5e4ed846234b.png", 
                        ],
                        offer_price: {
                            amount: 510,
                            currency: "DKK",
                            formatted: "kr510"
                        },
                        location: {},
                        type: "listings",
                        sold: false,
                        active: true,
                        status: 2,
                        created_at: 1634374656,
                        start_at: 1634722167,
                        end_at: 1634722167,
                        likes: 0,
                        max_quantity: 20,
                        account: {
                            id: 223,
                            name: "Angela",
                            location: {},
                            unique_name: "",
                            description: "I own special edition sneakers (Yeez, Air Jordan) ",
                            total_followers: 1,
                            total_listings: 7,
                            images: [
                                "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/42917/a25fe9b4-91d1-4f8d-b2d5-0a071020fb1b.png", 
                            ],
                            type: "accounts",
                            active: true,
                            status: 2,
                            following: false,
                            user: {
                                email_verified: true,
                                blocked: false,
                                id: "6d49f2a3-0b10-44bc-b46c-d804001ffec9",
                                first_name: "Angela",
                                last_name: "M",
                                profile_pic: "",
                                email: "jk@istrata.co",
                                mobile: "",
                                dial_code: "",
                                created_at: 1634373500,
                                updated_at: 1634386699
                            },
                            category_id: []
                        },
                        distance: 0,
                        in_cart: false,
                        liked: false,
                        title: "iotlet",
                        description: ""
                    },
                    {
                        id: 510,
                        account_id: 223,
                        list_price: {
                            amount: 231,
                            currency: "DKK",
                            formatted: "kr231"
                        },
                        category_id: [
                            1838
                        ],
                        currency_id: 246,
                        offer_percent: 10,
                        stock: 2,
                        shipping_charges: {
                            amount: 0,
                            currency: "DKK",
                            formatted: "kr0"
                        },
                        images: [
                            "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/15696/ce0bc373-e8c5-4cf9-86c1-ebc0cf847182.png", 
                        ],
                        offer_price: {
                            amount: 23.1,
                            currency: "DKK",
                            formatted: "kr23.1"
                        },
                        location: {},
                        type: "listings",
                        sold: false,
                        active: true,
                        status: 2,
                        created_at: 1634374434,
                        start_at: 1634374434,
                        end_at: 1634374434,
                        likes: 0,
                        max_quantity: 20,
                        account: {
                            id: 223,
                            name: "Angela",
                            location: {},
                            unique_name: "",
                            description: "I own special edition sneakers (Yeez, Air Jordan) ",
                            total_followers: 1,
                            total_listings: 7,
                            images: [
                                "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/42917/a25fe9b4-91d1-4f8d-b2d5-0a071020fb1b.png", 
                            ],
                            type: "accounts",
                            active: true,
                            status: 2,
                            following: false,
                            user: {
                                email_verified: true,
                                blocked: false,
                                id: "6d49f2a3-0b10-44bc-b46c-d804001ffec9",
                                first_name: "Angela",
                                last_name: "M",
                                profile_pic: "",
                                email: "jk@istrata.co",
                                mobile: "",
                                dial_code: "",
                                created_at: 1634373500,
                                updated_at: 1634386699
                            },
                            category_id: []
                        },
                        distance: 0,
                        in_cart: false,
                        liked: false,
                        title: "Jordan 4 Retro",
                        description: "Originally released in 2006, the Air Jordan 4 Retro Lightning (2021) is one of the most renowned retro Jordan 4 colorways in Jordan Brand's catalog. It features a Tour Yellow Durabuck upper with black netted panels and dark grey eyelets. On the tongue, a black Jordan"
                    }, 
                ]
            },
            {
                scope_type: 3,
                title: "Invite your friends to Sneakers Hub",
                description: "Buy and Sell with Sneakers Hub"
            }, 
        ]
    }
};


/***/ }),

/***/ 62724:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _jsxRuntime = __webpack_require__(85893);
module.exports = {
    logo: "https://tradly-paas-sandbox.s3.amazonaws.com/images/sneakers/46472/542bb0e3-0f84-4b81-8f58-030b87815332.jpeg",
    store_icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#6e686e",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M22 7.82001C22.0048 7.75677 22.0048 7.69325 22 7.63001L20 2.63001C19.9219 2.43237 19.7828 2.26475 19.603 2.15147C19.4232 2.03819 19.212 1.98514 19 2.00001H5C4.79972 1.99982 4.604 2.05977 4.43818 2.17209C4.27237 2.28442 4.1441 2.44395 4.07 2.63001L2.07 7.63001C2.06518 7.69325 2.06518 7.75677 2.07 7.82001C2.03677 7.87568 2.01311 7.93652 2 8.00001C2.01113 8.69125 2.20123 9.36781 2.55174 9.96369C2.90226 10.5596 3.40124 11.0544 4 11.4V21C4 21.2652 4.10536 21.5196 4.29289 21.7071C4.48043 21.8947 4.73478 22 5 22H19C19.2652 22 19.5196 21.8947 19.7071 21.7071C19.8946 21.5196 20 21.2652 20 21V11.44C20.6046 11.091 21.1072 10.5898 21.4581 9.98635C21.809 9.38287 21.9958 8.69807 22 8.00001C22.0094 7.94038 22.0094 7.87965 22 7.82001ZM13 20H11V16H13V20ZM18 20H15V15C15 14.7348 14.8946 14.4804 14.7071 14.2929C14.5196 14.1054 14.2652 14 14 14H10C9.73478 14 9.48043 14.1054 9.29289 14.2929C9.10536 14.4804 9 14.7348 9 15V20H6V12C6.56947 11.9968 7.13169 11.872 7.64905 11.634C8.16642 11.3961 8.627 11.0503 9 10.62C9.37537 11.0456 9.83701 11.3865 10.3542 11.62C10.8715 11.8535 11.4325 11.9743 12 11.9743C12.5675 11.9743 13.1285 11.8535 13.6458 11.62C14.163 11.3865 14.6246 11.0456 15 10.62C15.373 11.0503 15.8336 11.3961 16.3509 11.634C16.8683 11.872 17.4305 11.9968 18 12V20ZM18 10C17.4696 10 16.9609 9.7893 16.5858 9.41423C16.2107 9.03915 16 8.53045 16 8.00001C16 7.7348 15.8946 7.48044 15.7071 7.29291C15.5196 7.10537 15.2652 7.00001 15 7.00001C14.7348 7.00001 14.4804 7.10537 14.2929 7.29291C14.1054 7.48044 14 7.7348 14 8.00001C14 8.53045 13.7893 9.03915 13.4142 9.41423C13.0391 9.7893 12.5304 10 12 10C11.4696 10 10.9609 9.7893 10.5858 9.41423C10.2107 9.03915 10 8.53045 10 8.00001C10 7.7348 9.89464 7.48044 9.70711 7.29291C9.51957 7.10537 9.26522 7.00001 9 7.00001C8.73478 7.00001 8.48043 7.10537 8.29289 7.29291C8.10536 7.48044 8 7.7348 8 8.00001C8.00985 8.26266 7.96787 8.52467 7.87646 8.77109C7.78505 9.01751 7.646 9.24351 7.46725 9.43619C7.28849 9.62887 7.07354 9.78446 6.83466 9.89407C6.59578 10.0037 6.33764 10.0652 6.075 10.075C5.54457 10.0949 5.02796 9.90327 4.63882 9.54226C4.44614 9.36351 4.29055 9.14855 4.18094 8.90967C4.07133 8.67079 4.00985 8.41266 4 8.15001L5.68 4.00001H18.32L20 8.15001C19.9621 8.65403 19.7348 9.125 19.3637 9.46822C18.9927 9.81143 18.5054 10.0014 18 10Z"
        })
    }),
    wishlist_icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#6e686e",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M21.6328 6.64689C21.3187 5.91948 20.8657 5.2603 20.2992 4.70627C19.7323 4.15058 19.064 3.70898 18.3305 3.40549C17.5699 3.08953 16.7541 2.92781 15.9305 2.9297C14.775 2.9297 13.6477 3.24611 12.668 3.84377C12.4336 3.98674 12.2109 4.14377 12 4.31486C11.7891 4.14377 11.5664 3.98674 11.332 3.84377C10.3523 3.24611 9.225 2.9297 8.06953 2.9297C7.2375 2.9297 6.43125 3.08908 5.66953 3.40549C4.93359 3.71017 4.27031 4.14845 3.70078 4.70627C3.13359 5.25968 2.6805 5.91901 2.36719 6.64689C2.04141 7.40392 1.875 8.20783 1.875 9.03517C1.875 9.81564 2.03438 10.6289 2.35078 11.4563C2.61563 12.1477 2.99531 12.8649 3.48047 13.5891C4.24922 14.7352 5.30625 15.9305 6.61875 17.1422C8.79375 19.1508 10.9477 20.5383 11.0391 20.5945L11.5945 20.9508C11.8406 21.1078 12.157 21.1078 12.4031 20.9508L12.9586 20.5945C13.05 20.536 15.2016 19.1508 17.3789 17.1422C18.6914 15.9305 19.7484 14.7352 20.5172 13.5891C21.0023 12.8649 21.3844 12.1477 21.6469 11.4563C21.9633 10.6289 22.1227 9.81564 22.1227 9.03517C22.125 8.20783 21.9586 7.40392 21.6328 6.64689Z"
        })
    }),
    sign_in_icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "15",
        height: "24",
        viewBox: "0 0 20 22",
        fill: "#ffffff",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M13.71 11.7099C14.6904 10.9385 15.406 9.8808 15.7572 8.68382C16.1085 7.48684 16.0779 6.21015 15.6698 5.03135C15.2617 3.85255 14.4963 2.83027 13.4801 2.10674C12.4639 1.3832 11.2474 0.994385 10 0.994385C8.75255 0.994385 7.53611 1.3832 6.51993 2.10674C5.50374 2.83027 4.73834 3.85255 4.33021 5.03135C3.92208 6.21015 3.89151 7.48684 4.24276 8.68382C4.59401 9.8808 5.3096 10.9385 6.29 11.7099C4.61007 12.3829 3.14428 13.4992 2.04889 14.9398C0.953495 16.3804 0.26956 18.0912 0.0699967 19.8899C0.0555513 20.0212 0.0671132 20.1541 0.104022 20.2809C0.140931 20.4078 0.202464 20.5261 0.285108 20.6292C0.452016 20.8374 0.69478 20.9707 0.959997 20.9999C1.22521 21.0291 1.49116 20.9517 1.69932 20.7848C1.90749 20.6179 2.04082 20.3751 2.07 20.1099C2.28958 18.1551 3.22168 16.3497 4.68822 15.0387C6.15475 13.7277 8.0529 13.0029 10.02 13.0029C11.9871 13.0029 13.8852 13.7277 15.3518 15.0387C16.8183 16.3497 17.7504 18.1551 17.97 20.1099C17.9972 20.3556 18.1144 20.5825 18.2991 20.7469C18.4838 20.9113 18.7228 21.0014 18.97 20.9999H19.08C19.3421 20.9697 19.5817 20.8372 19.7466 20.6311C19.9114 20.4251 19.9881 20.1622 19.96 19.8999C19.7595 18.0961 19.0719 16.3809 17.9708 14.9381C16.8698 13.4953 15.3969 12.3794 13.71 11.7099ZM10 10.9999C9.20887 10.9999 8.43551 10.7653 7.77772 10.3258C7.11992 9.88623 6.60723 9.26152 6.30448 8.53061C6.00173 7.79971 5.92251 6.99544 6.07686 6.21952C6.2312 5.4436 6.61216 4.73086 7.17157 4.17145C7.73098 3.61204 8.44371 3.23108 9.21964 3.07674C9.99556 2.9224 10.7998 3.00161 11.5307 3.30436C12.2616 3.60711 12.8863 4.1198 13.3259 4.7776C13.7654 5.4354 14 6.20876 14 6.99988C14 8.06075 13.5786 9.07816 12.8284 9.82831C12.0783 10.5785 11.0609 10.9999 10 10.9999Z"
        })
    })
};


/***/ }),

/***/ 76025:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _jsxRuntime = __webpack_require__(85893);
module.exports = {
    facebook_icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M20.9 2H3.1C2.80826 2 2.52847 2.11589 2.32218 2.32218C2.11589 2.52847 2 2.80826 2 3.1V20.9C2 21.0445 2.02845 21.1875 2.08373 21.321C2.13901 21.4544 2.22004 21.5757 2.32218 21.6778C2.42433 21.78 2.54559 21.861 2.67905 21.9163C2.81251 21.9715 2.95555 22 3.1 22H12.68V14.25H10.08V11.25H12.68V9C12.6261 8.47176 12.6885 7.93813 12.8627 7.43654C13.0369 6.93495 13.3188 6.47755 13.6885 6.09641C14.0582 5.71528 14.5068 5.41964 15.0028 5.23024C15.4989 5.04083 16.0304 4.96225 16.56 5C17.3383 4.99521 18.1163 5.03528 18.89 5.12V7.82H17.3C16.04 7.82 15.8 8.42 15.8 9.29V11.22H18.8L18.41 14.22H15.8V22H20.9C21.0445 22 21.1875 21.9715 21.321 21.9163C21.4544 21.861 21.5757 21.78 21.6778 21.6778C21.78 21.5757 21.861 21.4544 21.9163 21.321C21.9715 21.1875 22 21.0445 22 20.9V3.1C22 2.95555 21.9715 2.81251 21.9163 2.67905C21.861 2.54559 21.78 2.42433 21.6778 2.32218C21.5757 2.22004 21.4544 2.13901 21.321 2.08373C21.1875 2.02845 21.0445 2 20.9 2Z",
            fill: "#4867aa"
        })
    }),
    telegram_icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M11.9941 2C10.0163 2 8.08293 2.58649 6.43844 3.6853C4.79395 4.78412 3.51223 6.3459 2.75535 8.17317C1.99847 10.0004 1.80044 12.0111 2.18629 13.9509C2.57214 15.8907 3.52455 17.6725 4.92308 19.0711C6.3216 20.4696 8.10343 21.422 10.0432 21.8079C11.9831 22.1937 13.9937 21.9957 15.821 21.2388C17.6482 20.4819 19.21 19.2002 20.3088 17.5557C21.4077 15.9112 21.9941 13.9778 21.9941 12C21.9943 10.6868 21.7357 9.38634 21.2332 8.17304C20.7307 6.95973 19.9941 5.8573 19.0655 4.92869C18.1368 4.00008 17.0344 3.26349 15.8211 2.76098C14.6078 2.25847 13.3074 1.99989 11.9941 2ZM15.1737 17.1525C15.1362 17.2458 15.0793 17.33 15.0066 17.3996C14.934 17.4691 14.8473 17.5223 14.7524 17.5556C14.6575 17.5889 14.5566 17.6015 14.4565 17.5926C14.3563 17.5837 14.2592 17.5535 14.1717 17.504L11.457 15.3946L9.71466 17.002C9.67424 17.0319 9.62695 17.0511 9.57714 17.0579C9.52734 17.0647 9.47662 17.0589 9.42967 17.0409L9.76366 14.0525L9.77436 14.061L9.78118 14.002C9.78118 14.002 14.6662 9.55445 14.8652 9.36496C15.0667 9.17596 15.0002 9.13496 15.0002 9.13496C15.0117 8.90443 14.6387 9.13496 14.6387 9.13496L8.16614 13.299L5.47066 12.381C5.47066 12.381 5.05666 12.2325 5.01766 11.906C4.97666 11.582 5.48415 11.406 5.48415 11.406L16.2011 7.14849C16.2011 7.14849 17.0821 6.75597 17.0821 7.406L15.1737 17.1525Z",
            fill: "#25a2e0"
        })
    }),
    twitter_icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M22 5.79997C21.2483 6.12606 20.4534 6.34163 19.64 6.43997C20.4982 5.92729 21.1413 5.12075 21.45 4.16997C20.6436 4.65003 19.7608 4.98826 18.84 5.16997C18.2245 4.50254 17.405 4.05826 16.5098 3.90682C15.6147 3.75537 14.6945 3.90532 13.8938 4.33315C13.093 4.76099 12.4569 5.4425 12.0852 6.2708C11.7135 7.09911 11.6273 8.02736 11.84 8.90997C10.2094 8.82749 8.61444 8.40292 7.15865 7.66383C5.70287 6.92474 4.41885 5.88766 3.39 4.61997C3.02914 5.25013 2.83952 5.96379 2.84 6.68997C2.83872 7.36435 3.00422 8.02858 3.32176 8.62353C3.63929 9.21848 4.09902 9.72568 4.66 10.1C4.00798 10.0822 3.36989 9.90726 2.8 9.58997V9.63997C2.80489 10.5849 3.13599 11.4991 3.73731 12.2279C4.33864 12.9568 5.17326 13.4556 6.1 13.64C5.74326 13.7485 5.37287 13.8058 5 13.81C4.74189 13.807 4.48442 13.7835 4.23 13.74C4.49391 14.5528 5.00462 15.2631 5.69107 15.7721C6.37753 16.2811 7.20558 16.5635 8.06 16.58C6.6172 17.7152 4.83588 18.3348 3 18.34C2.66574 18.3411 2.33174 18.321 2 18.28C3.87443 19.4902 6.05881 20.1327 8.29 20.13C9.82969 20.146 11.3571 19.855 12.7831 19.274C14.2091 18.6931 15.505 17.8338 16.5952 16.7465C17.6854 15.6591 18.548 14.3654 19.1326 12.9409C19.7172 11.5164 20.012 9.98969 20 8.44997C20 8.27996 20 8.09997 20 7.91997C20.7847 7.33478 21.4615 6.61739 22 5.79997Z",
            fill: "#5da9dd"
        })
    }),
    youtube_icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M23 9.70998C23.0495 8.27864 22.7365 6.858 22.09 5.57998C21.6514 5.05558 21.0427 4.70169 20.37 4.57998C17.5875 4.32751 14.7936 4.22403 12 4.26998C9.21667 4.22194 6.43274 4.32208 3.66003 4.56998C3.11185 4.6697 2.60454 4.92683 2.20003 5.30998C1.30003 6.13998 1.20003 7.55998 1.10003 8.75998C0.954939 10.9175 0.954939 13.0824 1.10003 15.24C1.12896 15.9154 1.22952 16.5858 1.40003 17.24C1.5206 17.745 1.76455 18.2123 2.11003 18.6C2.51729 19.0034 3.03641 19.2752 3.60003 19.38C5.75594 19.6461 7.92824 19.7564 10.1 19.71C13.6 19.76 16.67 19.71 20.3 19.43C20.8775 19.3316 21.4112 19.0595 21.83 18.65C22.11 18.3699 22.3191 18.0271 22.44 17.65C22.7977 16.5526 22.9733 15.4041 22.96 14.25C23 13.69 23 10.31 23 9.70998ZM9.74003 14.85V8.65998L15.66 11.77C14 12.69 11.81 13.73 9.74003 14.85Z",
            fill: "#fe0000"
        })
    }),
    whatsapp_icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M22 6.55C21.9888 6.11857 21.9554 5.68801 21.9 5.26C21.8253 4.88512 21.7009 4.52191 21.53 4.18C21.3513 3.8091 21.1112 3.47103 20.82 3.18C20.5261 2.8922 20.1886 2.65259 19.82 2.47C19.4776 2.30244 19.1144 2.18137 18.74 2.11C18.3161 2.0465 17.8886 2.00976 17.46 2H6.55C6.11857 2.01124 5.68801 2.04461 5.26 2.1C4.88512 2.17467 4.52191 2.2991 4.18 2.47C3.8091 2.64874 3.47103 2.88877 3.18 3.18C2.8922 3.47391 2.65259 3.81139 2.47 4.18C2.30244 4.52236 2.18137 4.88558 2.11 5.26C2.0465 5.68393 2.00976 6.11145 2 6.54C2 6.73 2 7 2 7.08V16.92C2 17.03 2 17.27 2 17.45C2.01124 17.8814 2.04461 18.312 2.1 18.74C2.17467 19.1149 2.2991 19.4781 2.47 19.82C2.64874 20.1909 2.88877 20.529 3.18 20.82C3.47391 21.1078 3.81139 21.3474 4.18 21.53C4.52236 21.6976 4.88558 21.8186 5.26 21.89C5.68393 21.9535 6.11145 21.9902 6.54 22H17.45C17.8814 21.9888 18.312 21.9554 18.74 21.9C19.1149 21.8253 19.4781 21.7009 19.82 21.53C20.1909 21.3513 20.529 21.1112 20.82 20.82C21.1078 20.5261 21.3474 20.1886 21.53 19.82C21.6976 19.4776 21.8186 19.1144 21.89 18.74C21.9535 18.3161 21.9902 17.8886 22 17.46C22 17.27 22 17.03 22 16.92V7.08C22 7 22 6.73 22 6.55ZM12.23 19C11.0291 18.9941 9.84913 18.6845 8.8 18.1L5 19.1L6 15.38C5.35511 14.2965 5.00999 13.0609 5 11.8C5.00398 10.3829 5.4272 8.99872 6.21636 7.82171C7.00552 6.6447 8.12532 5.72753 9.43473 5.18572C10.7441 4.6439 12.1846 4.50167 13.5747 4.77694C14.9648 5.05221 16.2423 5.73266 17.2464 6.7326C18.2505 7.73255 18.9363 9.00725 19.2173 10.3962C19.4984 11.7851 19.3622 13.2262 18.8258 14.5378C18.2894 15.8495 17.3769 16.9731 16.2032 17.7671C15.0295 18.5612 13.647 18.9901 12.23 19ZM12.23 5.87C11.1698 5.88213 10.1318 6.17498 9.22156 6.71874C8.31135 7.26249 7.56148 8.03773 7.0483 8.96552C6.53512 9.89331 6.27695 10.9405 6.30008 12.0005C6.32322 13.0605 6.62683 14.0955 7.18 15L7.32 15.23L6.72 17.42L9 16.8L9.22 16.93C10.1296 17.4658 11.1644 17.7521 12.22 17.76C13.8113 17.76 15.3374 17.1279 16.4626 16.0026C17.5879 14.8774 18.22 13.3513 18.22 11.76C18.22 10.1687 17.5879 8.64258 16.4626 7.51736C15.3374 6.39214 13.8113 5.76 12.22 5.76L12.23 5.87ZM15.73 14.39C15.599 14.6085 15.4236 14.797 15.2152 14.9434C15.0068 15.0898 14.7699 15.1909 14.52 15.24C14.1465 15.3083 13.7621 15.2842 13.4 15.17C13.0593 15.0635 12.7254 14.9366 12.4 14.79C11.1637 14.1697 10.1094 13.2394 9.34 12.09C8.92188 11.5575 8.66819 10.9145 8.61 10.24C8.60405 9.95979 8.65705 9.68145 8.76558 9.42305C8.87412 9.16464 9.03575 8.93192 9.24 8.74C9.30016 8.67179 9.37397 8.61696 9.45665 8.57906C9.53934 8.54117 9.62905 8.52105 9.72 8.52H10C10.11 8.52 10.26 8.52 10.4 8.83C10.54 9.14 10.91 10.07 10.96 10.16C10.9846 10.208 10.9974 10.2611 10.9974 10.315C10.9974 10.3689 10.9846 10.422 10.96 10.47C10.9158 10.5787 10.8551 10.6799 10.78 10.77C10.69 10.88 10.59 11.01 10.51 11.09C10.43 11.17 10.33 11.27 10.43 11.45C10.7021 11.9092 11.0389 12.3268 11.43 12.69C11.8559 13.0664 12.3429 13.3673 12.87 13.58C13.05 13.67 13.16 13.66 13.26 13.58C13.36 13.5 13.71 13.06 13.83 12.88C13.95 12.7 14.07 12.73 14.23 12.79C14.39 12.85 15.28 13.28 15.46 13.37C15.64 13.46 15.75 13.5 15.8 13.58C15.8434 13.8417 15.8193 14.1102 15.73 14.36V14.39Z",
            fill: "#1a8829"
        })
    }),
    snapchat_icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M21.9734 6.68079C21.9722 6.32058 21.9391 5.96119 21.8747 5.60679C21.8028 5.17355 21.666 4.75362 21.469 4.36113C21.2533 3.94866 20.9725 3.57372 20.6373 3.25077C20.1311 2.75525 19.5057 2.39843 18.8216 2.2147C18.1933 2.0624 17.5478 1.99354 16.9016 2.00987L16.8979 2H7.09916L7.09861 2.00989C6.73104 2.007 6.36357 2.02344 5.99772 2.05914C5.59681 2.10188 5.20218 2.19073 4.82163 2.32391C4.19463 2.56035 3.63223 2.94131 3.18007 3.43586C2.72791 3.93041 2.39874 4.52461 2.21928 5.17023C2.06807 5.79342 1.9992 6.43374 2.01444 7.07483L2.00785 16.913V16.9139C2.00659 17.3594 2.03686 17.8044 2.09843 18.2456C2.1653 18.7125 2.30332 19.1663 2.50767 19.5914C2.7959 20.1586 3.2063 20.655 3.70933 21.0447C4.06864 21.331 4.47569 21.5516 4.91172 21.6964C5.55183 21.8943 6.21862 21.9922 6.88859 21.9869C7.30796 21.9895 7.72703 22 8.14659 21.9982C11.1932 21.9854 14.2399 22.0202 17.2867 21.9794C17.6891 21.9706 18.0901 21.928 18.4855 21.852C19.2328 21.7205 19.9283 21.3821 20.4931 20.8754C21.1584 20.297 21.6229 19.5224 21.8196 18.6631C21.9408 18.0877 21.9987 17.5008 21.9923 16.9129V16.7957C21.9923 16.7502 21.975 6.81219 21.9734 6.68079ZM19.2973 15.9306C19.1695 16.23 18.5233 16.4782 17.4294 16.6472C17.3268 16.663 17.2835 16.829 17.2243 17.1007C17.1999 17.2128 17.175 17.3228 17.1409 17.4384C17.1307 17.4871 17.1031 17.5304 17.0633 17.5602C17.0235 17.59 16.9742 17.6042 16.9246 17.6002H16.9075C16.8027 17.5965 16.6986 17.5833 16.5962 17.5609C16.3264 17.5044 16.0515 17.4753 15.7759 17.474C15.5776 17.4745 15.3798 17.4912 15.1842 17.524C14.7717 17.6285 14.3879 17.8245 14.0614 18.0975C13.5094 18.5688 12.8158 18.8422 12.0907 18.8743C12.0492 18.8743 12.0096 18.8728 11.9795 18.8713C11.9556 18.8734 11.931 18.8743 11.9062 18.8743C11.1816 18.8424 10.4884 18.5692 9.93675 18.0981C9.6099 17.8248 9.22575 17.6285 8.81275 17.5239C8.61728 17.4911 8.41946 17.4744 8.22126 17.4739C7.94537 17.4768 7.67051 17.5079 7.40095 17.5667C7.29871 17.5905 7.1946 17.6054 7.08979 17.6113C7.03699 17.6174 6.98384 17.6036 6.94065 17.5726C6.89746 17.5416 6.86732 17.4957 6.85609 17.4438C6.8216 17.3267 6.79688 17.2132 6.77302 17.1039C6.71333 16.8308 6.67002 16.6641 6.56782 16.6483C5.4741 16.4795 4.82792 16.231 4.69926 15.93C4.68614 15.8999 4.67845 15.8678 4.67655 15.835C4.67413 15.7917 4.68777 15.7491 4.71487 15.7153C4.74197 15.6815 4.7806 15.6589 4.82334 15.6519C5.72779 15.4881 6.54279 15.0035 7.11869 14.2871C7.43569 13.9203 7.69926 13.5106 7.90159 13.0701L7.90559 13.0617C7.96517 12.9641 8.00274 12.8548 8.01566 12.7412C8.02859 12.6277 8.01656 12.5127 7.98042 12.4043C7.83949 12.072 7.37281 11.9239 7.06403 11.8259C6.98725 11.8017 6.91462 11.7787 6.85676 11.7556C6.58302 11.6475 6.13288 11.4191 6.19282 11.1038C6.23874 10.985 6.32065 10.8836 6.42708 10.8136C6.53351 10.7437 6.65913 10.7088 6.78638 10.7138C6.84817 10.7124 6.9095 10.7246 6.96601 10.7497C7.19647 10.8677 7.44973 10.9346 7.70844 10.9457C7.86221 10.9566 8.01457 10.9101 8.13593 10.815C8.12788 10.6691 8.1191 10.5232 8.10957 10.3774C7.96894 9.39162 8.02902 8.38763 8.2862 7.4257C8.58859 6.73525 9.08766 6.14917 9.7211 5.74063C10.3545 5.33208 11.0943 5.11917 11.848 5.12848L12.1427 5.12573C12.8975 5.11611 13.6384 5.32898 14.2729 5.73777C14.9075 6.14657 15.4076 6.7332 15.7109 7.42444C15.9681 8.38725 16.0281 9.39209 15.8873 10.3787L15.8843 10.4264C15.8757 10.5621 15.8678 10.6905 15.861 10.8149C15.9712 10.902 16.1084 10.9479 16.2488 10.9446C16.4925 10.9263 16.7301 10.8601 16.9482 10.7498C17.0205 10.7185 17.0986 10.703 17.1773 10.7044C17.2667 10.704 17.3553 10.721 17.4383 10.7543L17.4423 10.7559C17.5362 10.7782 17.6213 10.828 17.6867 10.8989C17.7521 10.9698 17.7949 11.0586 17.8095 11.1539C17.8123 11.3067 17.6987 11.5351 17.1402 11.7557C17.083 11.7784 17.01 11.8015 16.9329 11.826C16.6239 11.9241 16.1576 12.0721 16.0166 12.4042C15.9804 12.5125 15.9684 12.6275 15.9813 12.7411C15.9942 12.8546 16.0318 12.9639 16.0915 13.0614L16.0955 13.07C16.3749 13.7084 16.7982 14.2736 17.3322 14.7215C17.8662 15.1693 18.4964 15.4877 19.1738 15.6517C19.2165 15.6588 19.2551 15.6814 19.2822 15.7152C19.3093 15.749 19.3229 15.7916 19.3205 15.8348C19.3185 15.8679 19.3107 15.9003 19.2973 15.9306Z",
            fill: "#121212"
        })
    })
};


/***/ }),

/***/ 6597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ feature1; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* eslint-disable no-unused-expressions */ 

function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
var feature1 = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};


/***/ }),

/***/ 74756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99741);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(constant_url__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




function Cta() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "max-w-6xl mx-auto px-4 sm:px-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pb-12 md:pb-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative bg-gray-100 rounded py-10 px-8 md:py-16 md:px-12 shadow-2xl overflow-hidden",
                    "data-aos": "zoom-y-out",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute right-0 bottom-0 pointer-events-none hidden lg:block",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                width: "428",
                                height: "328",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("radialGradient", {
                                            cx: "35.542%",
                                            cy: "34.553%",
                                            fx: "35.542%",
                                            fy: "34.553%",
                                            r: "96.031%",
                                            id: "ni-a",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                                    "stop-color": "#34CDB1",
                                                    "stop-opacity": "0.25"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                                    offset: "1",
                                                    "stop-color": "#34CDB1",
                                                    "stop-opacity": "0"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                        fill: "none",
                                        fillRule: "evenodd",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                                fill: "#34CDB1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".04",
                                                        cx: "185",
                                                        cy: "15.576",
                                                        rx: "16",
                                                        ry: "15.576"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".24",
                                                        cx: "100",
                                                        cy: "68.402",
                                                        rx: "24",
                                                        ry: "23.364"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "29",
                                                        cy: "251.231",
                                                        rx: "29",
                                                        ry: "28.231"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".64",
                                                        cx: "29",
                                                        cy: "251.231",
                                                        rx: "8",
                                                        ry: "7.788"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "342",
                                                        cy: "31.303",
                                                        rx: "8",
                                                        ry: "7.788"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".48",
                                                        cx: "62",
                                                        cy: "126.811",
                                                        rx: "2",
                                                        ry: "1.947"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "78",
                                                        cy: "7.072",
                                                        rx: "2",
                                                        ry: "1.947"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".64",
                                                        cx: "185",
                                                        cy: "15.576",
                                                        rx: "6",
                                                        ry: "5.841"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                fill: "url(#ni-a)",
                                                cx: "276",
                                                cy: "237",
                                                r: "200"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col lg:flex-row justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mb-6 lg:mr-16 lg:mb-0 text-center lg:text-left",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                            className: "h3 text-black mb-2",
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400",
                                                    children: "Simple and FREE."
                                                }),
                                                " ",
                                                "Launch your project today!"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "text-black text-lg opacity-75",
                                            children: [
                                                "- Launch Marketplaces, Online Storefronts, Booking Apps, Classifieds, Directories, Partner Portals, App Stores, etc.",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                " - Tradly pricing starts with ZERO. You pay only when you grow.",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                " - Free No-code Integrations, No-Code Editor"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "btn whitespace-nowrap bg-primary text-white px-20 ",
                                        href: "/signup",
                                        children: "SIGN UP NOW"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Cta);


/***/ }),

/***/ 44835:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_Transition_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1193);




function Modal(param) {
    var children = param.children, id = param.id, ariaLabel = param.ariaLabel, show = param.show, handleClose = param.handleClose;
    var modalContent = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // close the modal on click outside
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var clickHandler = function(param) {
            var target = param.target;
            if (!show || modalContent.current.contains(target)) return;
            handleClose();
        };
        document.addEventListener("click", clickHandler);
        return function() {
            return document.removeEventListener("click", clickHandler);
        };
    });
    // close the modal if the esc key is pressed
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var keyHandler = function(param) {
            var keyCode = param.keyCode;
            if (keyCode !== 27) return;
            handleClose();
        };
        document.addEventListener("keydown", keyHandler);
        return function() {
            return document.removeEventListener("keydown", keyHandler);
        };
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_Transition_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "fixed inset-0 z-50 bg-white bg-opacity-75 transition-opacity blur",
                show: show,
                enter: "transition ease-out duration-200",
                enterStart: "opacity-0",
                enterEnd: "opacity-100",
                leave: "transition ease-out duration-100",
                leaveStart: "opacity-100",
                leaveEnd: "opacity-0",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_Transition_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                id: id,
                className: "fixed inset-0 z-50 overflow-hidden flex items-center justify-center transform px-4 sm:px-6",
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": ariaLabel,
                show: show,
                enter: "transition ease-out duration-200",
                enterStart: "opacity-0 scale-95",
                enterEnd: "opacity-100 scale-100",
                leave: "transition ease-out duration-200",
                leaveStart: "opacity-100 scale-100",
                leaveEnd: "opacity-0 scale-95",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-white overflow-auto max-w-6xl w-full max-h-full",
                    ref: modalContent,
                    children: children
                })
            })
        ]
    });
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Modal)));
Modal.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_3___default().element)),
        (prop_types__WEBPACK_IMPORTED_MODULE_3___default().element.isRequired)
    ]),
    id: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    ariaLabel: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    show: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool.isRequired),
    handleClose: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired)
};


/***/ }),

/***/ 27087:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bg_style":"common_bg_style__VShld"};

/***/ })

}]);